{
  "common": {
    "app_name": "Tago",
    "welcome": "Welcome",
    "continue": "Continue",
    "cancel": "Cancel",
    "save": "Save",
    "delete": "Delete",
    "edit": "Edit",
    "search": "Search",
    "filter": "Filter",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success",
    "confirm": "Confirm",
    "back": "Back",
    "next": "Next",
    "done": "Done",
    "close": "Close",
    "retry": "Retry",
    "yes": "Yes",
    "no": "No",
    "security": "Security",
    "preferences": "Preferences",
    "optional": "optional",
    "actions": "Actions",
    "pending": "Pending",
    "saved": "Saved",
    "verified": "Verified",
    "you": "you",
    "or": "or",
    "toggle_language": "Toggle language",
    "clear": "Clear",
    "default_location": "Current location",
    "error_title": "We could not load this",
    "error_description": "Check your connection and try again."
  },
  "account_status": {
    "eyebrow": "Account status",
    "archived_title": "Account archived",
    "suspended_title": "Account under review",
    "suspended_until_title": "Account temporarily paused",
    "archived_body": "This account can no longer operate on Tago. We keep the history for security and compliance.",
    "suspended_body": "For security, we temporarily paused operational access. Our team can review the case with you.",
    "suspended_until_body": "You can use Tago again when the pause ends, unless our team needs an additional review.",
    "reason_label": "Reason",
    "until_label": "Available again",
    "support": "Contact support",
    "sign_out": "Sign out",
    "support_subject": "Tago account review",
    "support_body": "Hi Tago, I need help with my account status: {{email}}."
  },
  "auth": {
    "login": "Log In",
    "register": "Sign Up",
    "logout": "Log Out",
    "email": "Email",
    "password": "Password",
    "password_placeholder": "Your password",
    "forgot_password": "Forgot Password?",
    "reset_password": "Reset Password",
    "phone": "Phone",
    "verify_phone": "Verify phone",
    "verify_email": "Verify Email",
    "verification_code": "Verification Code",
    "create_account": "Create Account",
    "already_have_account": "Already have an account?",
    "dont_have_account": "Don't have an account?",
    "onboarding": "Welcome to Tago",
    "welcome_title": "Welcome to Tago",
    "welcome_subtitle": "Your best option for getting around El Salvador!",
    "sign_in_button": "Sign In",
    "create_account_button": "Create Account",
    "first_name": "Given names",
    "last_name": "Last names",
    "first_name_placeholder": "e.g. Carlos",
    "last_name_placeholder": "e.g. Ávila",
    "confirm_password": "Confirm password",
    "phone_placeholder": "+503 XXXX XXXX",
    "phone_optional": "Phone (optional)",
    "phone_optional_hint": "You can add it later. We verify your email first — no phone code at this step.",
    "register_progressive_hint": "You can add your name, phone, and date of birth later — only once, when needed.",
    "email_placeholder": "email@example.com",
    "dob_label": "Date of birth",
    "dob_day": "DD",
    "dob_month": "MM",
    "dob_year": "YYYY",
    "dob_helper": "DD / MM / YYYY · Must be 18+ to book",
    "dob_day_a11y": "Day",
    "dob_month_a11y": "Month",
    "dob_year_a11y": "Year",
    "continue_with_google": "Continue with Google",
    "continue_with_apple": "Continue with Apple",
    "continue_with_phone": "Continue with Phone",
    "or_divider": "or",
    "forgot_password_title": "Reset Password",
    "forgot_password_desc": "Enter your email and we'll send you a link to reset your password.",
    "forgot_password_sent": "If the email exists, you'll receive a link to reset your password.",
    "send_reset_link": "Send Reset Link",
    "verify_phone_title": "Verify your phone",
    "verify_phone_desc": "Enter the 6-digit code we sent to {{phone}} on WhatsApp",
    "verify_phone_sending_title": "We're sending your code",
    "verify_phone_sending_desc": "We're requesting a WhatsApp code for {{phone}}. Wait for this confirmation before entering it.",
    "verify_phone_sending_button": "Sending code…",
    "verify_current_phone_desc": "Before changing it, confirm your current number: {{phone}}. We sent you a code via WhatsApp.",
    "verify_phone_sms_unavailable_title": "We couldn't send the code",
    "verify_phone_sms_unavailable_body": "The send failed — it isn't on its way. Try again in a moment, or continue another way.",
    "verify_phone_sms_unavailable_send_body": "The send failed — it isn't on its way. Try again in a moment, or continue another way.",
    "verify_phone_sms_unavailable_resend_body": "The resend failed — it isn't on its way. Try again in a moment, or continue another way.",
    "verify_phone_sms_busy_title": "Too many codes right now",
    "verify_phone_sms_busy_body": "Sending is at capacity. Your number is fine — wait a moment and try again.",
    "verify_phone_sms_quota_title": "Temporary send limit",
    "verify_phone_sms_quota_body": "You requested several codes in a row. Wait a bit and try again, or message us on WhatsApp and we'll verify you manually.",
    "verify_phone_sms_provider_title": "Delivery failed, not your number",
    "verify_phone_sms_provider_body": "Our provider refused the send. Don't wait for a code that isn't coming — continue another way, or message us and we'll activate you by hand.",
    "otp_recovery_sign_in_email": "Continue with email",
    "otp_recovery_create_account_email": "Continue with email",
    "otp_recovery_continue_email": "Continue with email",
    "otp_recovery_continue_google": "Continue with Google",
    "otp_recovery_continue_app": "Enter the app",
    "otp_recovery_verify_email": "Verify my email",
    "otp_recovery_hint": "You can continue with email or Google. You won't lose progress.",
    "verify_phone_sms_unavailable_retry": "Send again",
    "verify_phone_sms_unavailable_retry_in": "Retry in {{seconds}}s",
    "verify_phone_sms_unavailable_change_number": "Use another number",
    "verify_phone_sms_unavailable_support": "Message us on WhatsApp",
    "verify_phone_sms_unavailable_support_short": "WhatsApp",
    "verify_phone_sms_support_message": "Hi, I'm not receiving the Tago verification code.",
    "verify_phone_sms_support_unavailable": "We couldn't open WhatsApp. Try again or contact us on the web.",
    "verify_email_title": "Verify Email",
    "verify_email_desc": "We've sent a verification link to {{email}}",
    "verify_email_code_desc": "Enter the 6-digit code sent to {{email}}",
    "verify_email_check": "Check Email",
    "verify_email_send_code": "Send code to email",
    "verify_email_sent": "We sent a code to your email.",
    "link_email_title": "Add your email",
    "link_email_desc": "Your account started with phone. Add a real email to recover access, receive receipts, and complete verification.",
    "link_phone_title": "Add your phone",
    "link_phone_desc": "Your email is already verified. Add and verify your phone to protect your account and complete verification.",
    "resend_code": "Resend code",
    "resend_in": "Resend in {{seconds}}s",
    "session_expired": "Your session has expired. Please sign in again.",
    "enter_phone_title": "Sign In with Phone",
    "enter_phone_desc": "Enter your phone number and we'll send you a verification code on WhatsApp.",
    "phone_auth_unavailable_title": "Verification unavailable",
    "phone_auth_unavailable_desc": "We could not prepare phone verification right now. Sign in again and try once more in a minute.",
    "phone_signup_title": "Create Account with Phone",
    "phone_signup_desc": "Enter your number. We'll send a code on WhatsApp — name and other details only when needed.",
    "send_code": "Send code",
    "phone_signup_send_code": "Create account and send code",
    "new_password": "New Password",
    "reset_password_title": "New Password",
    "reset_password_desc": "Enter your new password.",
    "reset_password_button": "Reset Password",
    "reset_password_success": "Password reset successfully.",
    "reset_password_success_title": "Password Updated",
    "reset_password_success_desc": "Your password has been changed. Sign in with your new credentials.",
    "biometric_unlock_required": "Unlock required",
    "errors": {
      "invalid_credentials": "Those details don't match. Check them and try again, or recover access to your account.",
      "too_many_attempts": "Too many attempts. Try again in {{minutes}} minutes.",
      "otp_invalid": "Invalid code",
      "otp_expired": "That code expired. Request a new one.",
      "otp_send_failed": "Could not send code. Please try again.",
      "phone_undeliverable": "That number can't receive the code. Use the mobile where you have WhatsApp.",
      "otp_recently_sent": "We just sent you a code. Wait before asking for another.",
      "otp_rate_limited": "Too many attempts. Wait a moment and try again.",
      "otp_service_unavailable": "Verification isn't available right now. Try again in a few minutes.",
      "otp_too_many_attempts": "Too many wrong codes. Request a new one.",
      "phone_account_uses_email": "That number belongs to an account with an email. Sign in with your email or Google.",
      "otp_resend_failed": "Could not resend code. Please try again.",
      "session_missing": "Your session is not ready. Sign out, sign back in, and try again.",
      "signup_failed": "Could not create account",
      "account_exists": "An account already exists with this email. Sign in or reset your password.",
      "email_in_use": "That email is already linked to another account. Sign in with that email or use a different one.",
      "phone_in_use": "That phone is already linked to another account. Sign in with that number or use a different one.",
      "phone_link_failed": "We couldn't link your number. Try again.",
      "phone_link_refresh_failed": "Your number was verified, but we couldn't refresh your session. Try again.",
      "consent_write_failed": "Account created but we couldn't save your consent preferences. Please try again.",
      "network": "Connection error",
      "reset_failed": "We couldn't save your password. Please try again.",
      "password_unchanged": "That is already your current password. You can sign in with it or choose a different one to change it.",
      "password_weak": "Choose a stronger password with uppercase and lowercase letters and numbers.",
      "reset_link_expired": "This password reset link expired. Request a new one.",
      "email_verification_failed": "Could not send the email code. Please try again.",
      "social_failed": "Sign-in failed. Please try again.",
      "service_unavailable": "We cannot sign you in right now. Try again in a few minutes.",
      "google_failed": "Could not sign in with Google. Try again or use email/phone.",
      "google_not_configured": "Google sign-in is not configured correctly. We have been notified; use email or phone for now.",
      "google_play_services": "Google Play Services is unavailable or out of date. Update it and try again.",
      "google_internal": "We couldn't complete Google sign-in. Try once more, or sign in with your email and password.",
      "google_access_blocked": "Google blocked this account from Tago. If the Google Cloud OAuth app is in Testing, add this email as a test user or publish the app. You can also use email or phone.",
      "google_server_error": "Google succeeded, but Tago's server could not open the session. Wait a few seconds and try again. If it keeps failing, use email or phone.",
      "google_email_exists": "That Google email is already on Tago with another sign-in method. Use email and password, or reset your password.",
      "apple_failed": "Could not sign in with Apple. Try again or use email/phone.",
      "apple_unavailable": "Sign in with Apple is not available on this device. Use email, phone, or Google.",
      "phone_account_not_found": "No hay una cuenta con ese número. Creá una cuenta o revisá el número.",
      "phone_in_use_title": "Este número ya tiene cuenta",
      "phone_in_use_body": "Ese teléfono ya está vinculado a otra cuenta de Tago. Podés entrar con ese número o probar con otro.",
      "phone_in_use_enter": "Entrar con este número",
      "phone_in_use_other": "Usar otro número",
      "phone_change_needs_current": "To change your number, first confirm the one you have today. We sent a code to it."
    },
    "validation": {
      "first_name_min": "Minimum 2 characters",
      "first_name_max": "Maximum 50 characters",
      "last_name_min": "Minimum 2 characters",
      "last_name_max": "Maximum 50 characters",
      "email_invalid": "Invalid email",
      "phone_format": "Use a valid number from Central America, Mexico, the US, or Canada.",
      "phone_unsupported_country": "We don't verify numbers from that country yet. Use one from Central America, Mexico, the US, or Canada.",
      "phone_not_mobile": "That's a landline and can't receive WhatsApp. Use the mobile where you have WhatsApp.",
      "phone_unreachable": "That number can't receive the code. Check it or try another mobile line.",
      "password_min": "Minimum 8 characters",
      "password_max": "Maximum 128 characters",
      "password_letter": "At least one letter",
      "password_lowercase": "At least one lowercase letter",
      "password_uppercase": "At least one uppercase letter",
      "password_number": "At least one number",
      "passwords_mismatch": "Passwords don't match",
      "dob_required": "Date of birth is required",
      "dob_too_young": "You must be at least 18 to use Tago",
      "accept_terms_required": "Accept the Terms and Privacy Policy to continue"
    },
    "existing_phone_signed_in": "Ya tenías una cuenta con este número. Entraste con ella.",
    "oauth_failed": "No pudimos completar el inicio de sesión. Intentá de nuevo.",
    "verify_phone_later": "Verify later — you will need it before booking or publishing",
    "verify_phone_later_a11y": "Verify the phone later. It is required before booking or publishing."
  },
  "phone": {
    "country_picker_label": "Country: {{country}}",
    "country_picker_hint": "Tap to change the country code",
    "country_picker_title": "Choose your country",
    "country_picker_search": "Search country or code",
    "country_picker_empty": "No matches"
  },
  "consent": {
    "title": "Privacy Notice",
    "terms_and_privacy": "I accept the Terms of Service and Privacy Policy",
    "data_processing": "I authorize the processing of my personal data (D.L. 144/2024)",
    "cross_border": "I authorize international data transfer (AWS us-west-2, USA)",
    "marketing": "I agree to receive marketing communications",
    "view_privacy": "View privacy policy",
    "view_terms": "View terms of service",
    "required": "(required)",
    "optional": "(optional)"
  },
  "biometric": {
    "prompt_title": "Biometric Unlock",
    "prompt_message": "Enable fingerprint/Face ID unlock?",
    "prompt_desc": "Access Tago without entering your password.",
    "enable": "Enable",
    "skip": "Not now",
    "unlock": "Unlock Tago",
    "failed": "Could not verify your identity",
    "fallback": "Too many attempts. Use your password."
  },
  "tabs": {
    "explore": "Explore",
    "trips": "Trips",
    "messages": "Messages",
    "services": "Services",
    "hosting": "Hosting",
    "profile": "Profile",
    "tours": "Tours"
  },
  "tours": {
    "route": "{{origin}} → {{destination}}",
    "per_person": "per person",
    "up_to": "up to {{price}}",
    "from": "from",
    "tariffs": "Prices per vehicle",
    "no_dates": "No available dates yet",
    "host_verified": "Verified host",
    "seats": "seats",
    "available": "left",
    "full": "Full",
    "departure": "Pick your departure",
    "choose_vehicle": "Choose your transportation",
    "choose_vehicle_hint": "We show options with enough room for your whole group.",
    "choose_date": "When do you want to go?",
    "date": "Date",
    "time": "Time",
    "vehicle_total": "Vehicle total",
    "passengers": "Passengers",
    "increase_passengers": "Add a passenger",
    "decrease_passengers": "Remove a passenger",
    "max": "Max {{count}}",
    "passenger_range": "Minimum {{min}} · maximum {{max}}",
    "capacity": "Up to {{count}} passengers",
    "luggage": "Luggage",
    "luggage_hint": "Pick what each person is bringing.",
    "luggage_light": "Light",
    "luggage_beach": "Beach",
    "luggage_luggage": "Suitcases",
    "luggage_sports": "Sports gear",
    "book_now": "Get a quote",
    "reserve": "Book now",
    "reserve_hint": "We hold your seats for 15 minutes so you can complete payment.",
    "reserve_sign_in_hint": "Log in to continue with your booking.",
    "minimum_lead_time_hint": "The first available date is already selected; we leave one full calendar day to prepare your tour.",
    "minimum_group_unavailable": "This tour currently has no transportation available for the minimum group of {{count}} people.",
    "requirements": {
      "title": "Before you book",
      "phone": "Verify your phone to book. It's a one-time step and protects your purchase.",
      "email": "Verify your email to book.",
      "cta": "Verify to book"
    },
    "checkout": {
      "title": "Payment",
      "hold_remaining": "You have {{time}} to complete payment",
      "hold_soon": "Hurry: {{time}} left",
      "date": "Date",
      "total": "Total",
      "method": "Payment method",
      "pay_full": "Full payment",
      "pay_split": "Split payment",
      "how_many_pay": "How many are paying?",
      "each_pays": "Each pays {{amount}}",
      "create_split": "Create split",
      "split_created": "Split ready",
      "split_created_hint": "Share these links with your group so everyone pays their share.",
      "pay_my_share": "Pay my share ({{amount}})",
      "share": "Share",
      "share_part": "Share {{n}}",
      "card_option": "Credit or debit card",
      "card_number": "Card number",
      "card_expiry": "Expiry",
      "card_cvv": "CVV",
      "card_name": "Name on card",
      "email": "Email",
      "secure_note": "Payment protected by Tago. We don't store your card details.",
      "pay": "Pay {{amount}}",
      "email_required": "We need your email to continue with PayPal.",
      "invalid_card": "Check your card details.",
      "success_title": "Payment confirmed!",
      "success_body": "Your booking is ready. We'll send you the departure details.",
      "failed_title": "We couldn't charge",
      "failed_body": "The payment was declined. Try another card or try again.",
      "pending_title": "Payment processing",
      "pending_body": "We're confirming your payment. We'll let you know as soon as it clears.",
      "back_to_tours": "Back to Tours",
      "view_bookings": "View my bookings"
    },
    "bookings": {
      "title": "My bookings",
      "empty_title": "No bookings yet",
      "empty_body": "When you book a tour, it'll show up here.",
      "error_title": "We couldn't load your bookings",
      "error_body": "Check your connection and try again.",
      "unknown": "Tour",
      "cancel": "Cancel and refund",
      "complete_payment": "Complete payment",
      "view_trip": "View trip operation",
      "cancel_confirm_title": "Cancel this booking?",
      "cancel_confirm_body": "If you're within the window, we'll refund 100% to your original payment method.",
      "cancel_confirm_yes": "Yes, cancel",
      "cancel_confirm_no": "No, go back"
    },
    "booking_status": {
      "draft": "Draft",
      "capacity_held": "Held",
      "awaiting_payment": "Awaiting payment",
      "partially_paid": "Partially paid",
      "paid": "Paid",
      "in_progress": "In progress",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "expired": "Expired"
    },
    "split": {
      "title": "Pay your share",
      "subtitle": "You were invited to split a Tago tour.",
      "your_share": "Your share",
      "secure_brand": "Secure payment by Tago",
      "part_context": "Share {{position}} of {{total}}",
      "of_total": "of a {{amount}} total",
      "pay": "Pay {{amount}}",
      "paid_title": "All set!",
      "paid_body": "Your share was paid. The organizer takes care of the rest.",
      "pending_title": "Confirming payment…",
      "pending_body": "We're waiting for the bank's secure confirmation. This screen will update automatically."
    },
    "host": {
      "title": "Tours host",
      "subtitle": "Register as a host to publish your tours, units and departures.",
      "documents_hint": "You can start without documents. To publish tours we need your RNT and VMT permit.",
      "register": "Register as a host",
      "display_name": "Public name",
      "business_name": "Company (optional)",
      "rnt": "RNT / CORSATUR (optional)",
      "vmt": "VMT permit (optional)",
      "insurance": "Insurance policy (optional)",
      "status_pending": "Pending",
      "status_documents": "Documents submitted",
      "status_verified": "Verified",
      "status_suspended": "Suspended",
      "units_title": "My units",
      "no_units": "You haven't added units yet.",
      "unit_label": "Unit name",
      "unit_plate": "Plate",
      "unit_seats": "Seats",
      "unit_cargo": "Luggage (m³)",
      "add_unit": "Add unit",
      "edit_unit": "Edit unit",
      "save_changes": "Save changes",
      "cancel": "Cancel",
      "departures_title": "Departures",
      "no_experiences": "You don't have published tours yet.",
      "no_departures": "No dates yet.",
      "new_departure": "New departure",
      "departure_time": "Time",
      "add_departure": "Add departure",
      "host_bookings_title": "Bookings received",
      "no_bookings": "No bookings yet.",
      "start_booking": "Start",
      "complete_booking": "Complete",
      "open_operation": "Open trip operation",
      "operator_only_title": "Tago internal operations",
      "operator_only_body": "Tago is currently the only authorized Tours operator.",
      "available": "Available",
      "earned": "Earned",
      "disbursed": "Disbursed",
      "error": "We couldn't load your host profile."
    },
    "reviews": {
      "title": "Reviews",
      "empty": "No reviews yet.",
      "write": "Leave a review",
      "your_rating": "Your rating",
      "comment_label": "Comment",
      "comment_placeholder": "Tell us how it went (optional)",
      "submit": "Submit review",
      "thanks": "Thanks for your review!",
      "rating_count": "{{count}} reviews",
      "no_reviews_yet": "Be the first to review",
      "reviewed": "Reviewed",
      "error": "We couldn't submit your review."
    },
    "custom_quote": {
      "cta_title": "Design your own tour",
      "cta_body": "Choose a route, stops, and group. Get an instant quote.",
      "title": "Your custom tour",
      "subtitle": "Build a private itinerary at your pace.",
      "national_note": "Your start, stops, and destination must be in El Salvador.",
      "itinerary": "Your itinerary",
      "origin": "Starting point",
      "destination": "Final destination",
      "stop": "Stop {{count}}",
      "choose_place": "Choose a place",
      "add_stop": "Add a stop",
      "remove_stop": "Remove stop",
      "search_placeholder": "Search for a place in El Salvador",
      "searching": "Searching places…",
      "search_error": "We couldn't search places. Try again.",
      "no_places": "We couldn't find a place with that name.",
      "transport": "Your transport",
      "vehicle_microbus": "Minibus",
      "vehicle_microbus_detail": "Comfortable for groups up to 15",
      "vehicle_coaster": "Coaster",
      "vehicle_coaster_detail": "Room for groups up to 26",
      "vehicle_bus": "Bus",
      "vehicle_bus_detail": "Ideal for groups up to 45",
      "vehicle_choice_hint": "Choose the vehicle that fits your group best.",
      "get_quote": "See my quote",
      "quote_summary": "Your private quote",
      "quote_locked": "This quote already includes your route, group, and transport.",
      "detail_eyebrow": "Private quote",
      "detail_title": "Your route is ready to book",
      "detail_subtitle": "A national trip designed around your group.",
      "route_points": "{{count}} points",
      "expires_at": "Valid until {{time}}",
      "expired_title": "This quote has expired",
      "expired_body": "Rates and availability change. Let’s create a new quote for your itinerary.",
      "new_quote": "Create another quote",
      "error_national": "This itinerary must stay entirely within El Salvador.",
      "error_route": "We couldn't find a safe road route for those places. Try different points.",
      "error_capacity": "That vehicle cannot fit the whole group. Choose a larger one.",
      "error_unavailable": "Custom quoting is being prepared. Try again in a few minutes.",
      "error_conflict": "This quote changed while we were preparing it. Please try again.",
      "error": "We couldn't create your quote. Try again."
    },
    "start_point": {
      "title": "Starting point",
      "hint": "Choose where we pick you up, or keep the tour meeting point.",
      "default_badge": "Tour meeting point",
      "choose": "Choose another point",
      "change": "Change",
      "pickup_hint": "The driver will pick you up here.",
      "use_default": "Use the tour meeting point",
      "search_title": "Where should we pick you up?",
      "search_placeholder": "Address, hotel or landmark",
      "searching": "Searching places…",
      "search_empty": "We couldn't find a place with that name.",
      "search_error": "We couldn't search places. Try again.",
      "reference_points": "Landmarks"
    },
    "quote_title": "Your quote",
    "quote_meta": "{{origin}} → {{destination}} · {{date}}",
    "quote_breakdown": "{{count}} × {{price}}",
    "quote_remaining": "{{seats}} seats and {{cargo}} m³ left on that departure.",
    "quote_error": "Couldn't get a quote. Try again.",
    "quote_capacity": "Not enough seats or luggage space on that departure. Pick another date or fewer passengers.",
    "catalog_empty_title": "Tours coming soon",
    "catalog_empty_description": "We're putting together the first Tago Tours routes. Check back soon.",
    "catalog_empty_country_title": "Coming soon in {{country}}",
    "catalog_empty_country_description": "There are no departures from this country yet. You can switch countries above at any time.",
    "catalog_view_el_salvador": "View tours in El Salvador",
    "catalog_error_title": "Couldn't load tours",
    "catalog_error_description": "Check your connection and try again.",
    "detail_error_title": "We couldn't find that tour",
    "detail_error_description": "It may no longer be available. Go back to the list.",
    "loading": "Loading…",
    "retry": "Retry",
    "back": "Back",
    "stops": "Stops",
    "travel_info": {
      "title": "Before you travel",
      "meeting_point": "Meeting point",
      "what_to_bring": "What to bring",
      "documents": "Documents",
      "documents_recommended": "Recommended",
      "border_crossing": "Border",
      "policies": "Tour policies",
      "legal_notice": "Legal notice",
      "international_title": "International trip",
      "international_banner": "This tour crosses El Salvador's border. Get your documents ready and review the requirements before booking.",
      "consent_label": "I confirm I've read the trip requirements and terms.",
      "consent_label_international": "I confirm I've read the documents and border requirements and accept the trip terms.",
      "consent_required": "You need to accept the trip requirements to book."
    },
    "photo_gallery": {
      "title": "Along the route",
      "hint": "Swipe to explore the stops",
      "count": "{{count}} photos",
      "scroll_label": "Tour photo gallery",
      "open_photo": "Open {{label}} photo",
      "show_credits": "View photo credits",
      "hide_credits": "Hide photo credits",
      "credits_intro": "These photographs are used under open licenses. Tago cropped, resized and converted them to WebP.",
      "credit_line": "{{title}} · {{author}}",
      "source": "Source",
      "license": "License",
      "open_source": "Open source for {{label}}",
      "open_license": "Open license for {{label}}",
      "link_error": "We couldn't open that link. Please try again."
    },
    "catalog_subtitle": "Experiences in {{country}}",
    "catalog_count": "{{count}} experiences",
    "catalog_count_one": "{{count}} experience",
    "catalog_count_other": "{{count}} experiences",
    "catalog_empty_filter_title": "Nothing in this filter",
    "catalog_empty_filter_description": "Try All, or switch countries above.",
    "catalog_host_action": "Host",
    "catalog_country": "Country: {{country}}",
    "catalog_country_title": "Choose catalog country",
    "cover_alt": "{{title}} photo",
    "all": "All",
    "scope_national": "National",
    "scope_regional": "Central America",
    "stop_pickup": "Departure",
    "stop_waypoint": "Stop",
    "stop_destination": "Destination",
    "stop_marker": "Stop {{number}}: {{label}}",
    "map": {
      "driving_route": "Driving route",
      "loading_route": "Tracing the route…",
      "route_unavailable": "Road route unavailable",
      "load_error": "We couldn't load the map. Check your connection.",
      "gesture_hint": "Drag to move · pinch to zoom",
      "gesture_hint_web": "Scroll or pinch to zoom",
      "live_location": "Live location"
    },
    "trip": {
      "title": "Trip operation",
      "route": "{{origin}} → {{destination}}",
      "not_found": "We couldn't find this trip",
      "not_found_body": "Trip operations appear once the booking is paid and ready to depart.",
      "action_error": "We couldn't update the trip. Please try again.",
      "people_short": "people",
      "location_updated": "Location updated at {{time}}",
      "operator_verified": "Operation verified by Tago",
      "driver_verified": "Verified driver: {{name}}",
      "driver_required": "Assign a verified driver before boarding begins.",
      "driver_not_eligible": "This driver no longer meets the identity or licence requirements for this departure.",
      "driver_busy": "This driver already has another trip at that time.",
      "driver_picker_label": "Assigned driver",
      "driver_picker_placeholder": "Choose a driver",
      "driver_picker_title": "Assign driver",
      "driver_license_expires": "Licence valid through {{date}}",
      "driver_none_available": "No internal drivers have an eligible identity, licence, and schedule for this departure.",
      "map_unavailable": "The map will be available once mapping is configured for this platform.",
      "itinerary": "Itinerary",
      "operation": "Trip controls",
      "operation_body": "Changes sync in real time with passengers and Guardian.",
      "start_boarding": "Start boarding",
      "start_trip": "Start trip",
      "mark_arrival": "Mark arrival",
      "pause": "Pause trip",
      "resume": "Resume trip",
      "complete": "Complete trip",
      "mark_next_stop": "Stop: {{stop}}",
      "share_location": "Share location",
      "stop_location": "Stop sharing location",
      "location_foreground_hint": "Location is shared only while this screen remains open.",
      "location_permission": "We need while-in-use location permission to share the route.",
      "location_error": "We couldn't update the location. Check your connection.",
      "live_activity_enable": "Show progress on the Lock Screen",
      "acknowledge_emergency": "Acknowledge emergency",
      "resolve_emergency": "Mark emergency resolved",
      "emergency_button": "I need help",
      "emergency_confirm_title": "Activate emergency alert?",
      "emergency_confirm_body": "Tago will receive the alert with the trip's latest location.",
      "emergency_confirm_yes": "Activate alert",
      "status": {
        "scheduled": "Trip scheduled",
        "boarding": "Boarding in progress",
        "in_progress": "Trip in progress",
        "paused": "Trip paused",
        "arrived": "Arrived at destination",
        "completed": "Trip completed",
        "cancelled": "Trip cancelled"
      },
      "emergency": {
        "triggered": "Alert sent to Tago",
        "acknowledged": "Tago is responding to the alert"
      }
    },
    "guardian": {
      "title": "Tago Guardian",
      "body": "Share trip progress with someone you trust through a private link.",
      "setup": "Create Guardian link",
      "active": "{{name}} can see this trip's progress.",
      "replace_link": "Replace link",
      "revoke": "Revoke access",
      "setup_title": "Turn on Tago Guardian",
      "setup_body": "The link only shows the route, status, and latest trip location.",
      "guardian_name": "Trusted person's name",
      "responsible_adult": "Responsible adult's name",
      "emergency_contact": "Emergency contact",
      "emergency_phone": "Emergency phone",
      "includes_minors": "Minors are traveling",
      "consent": "I authorize sharing this trip's tracking with the person named above.",
      "consent_required": "You need to authorize access before creating the link.",
      "adult_required": "To share a trip with minors, the organizer account must be 18 or older and have a date of birth on file.",
      "create_link": "Create and share link",
      "share_title": "Tago Guardian tracking",
      "share_message": "You can follow my Tago trip here: {{url}}",
      "create_error": "We couldn't create the Guardian link. Please try again.",
      "public_title": "Tago Guardian",
      "shared_with": "Private tracking shared with {{name}}.",
      "privacy_note": "This link is private and temporary. It doesn't show personal or payment information.",
      "link_invalid": "This link is no longer available.",
      "link_invalid_body": "It may have expired or been revoked by the person who shared it."
    },
    "errors": {
      "generic": "Something went wrong. Please try again.",
      "bad_request": "The booking details aren't valid.",
      "forbidden": "You don't have permission to perform this action.",
      "operator_required": "This feature is reserved for Tago's internal team.",
      "minimum_lead_time": "Choose the first available date or a later one. There must be one full calendar day in between.",
      "minimum_passengers": "Tours require a minimum group of 10 people.",
      "start_point_outside_country": "For now we only pick up within El Salvador.",
      "start_point_unverified": "We couldn't verify the pickup point. Try again in a moment.",
      "unauthorized": "Your session expired. Sign in again.",
      "method_not_allowed": "Operation not allowed.",
      "provider_unsupported": "That payment method isn't available.",
      "booking_not_found": "We couldn't find that booking.",
      "booking_not_payable": "This booking can no longer be paid.",
      "booking_not_paid": "This booking isn't paid yet.",
      "payment_already_settled": "This booking is already paid.",
      "payment_not_found": "We couldn't find that payment.",
      "hold_expired": "Time to pay ran out. Pick your departure again.",
      "capacity_exceeded": "There's no room for that many on that departure anymore.",
      "departure_cancelled": "That departure was cancelled.",
      "departure_started": "That departure already started.",
      "unit_unavailable": "That vehicle isn't available for this tour.",
      "unit_busy": "That vehicle is already booked at that time. Pick another time or vehicle.",
      "custom_quote_mismatch": "This quote no longer matches your group or itinerary. Create a new one to continue.",
      "custom_quote_conflict": "We couldn't safely reuse this quote. Create a new one to continue.",
      "terms_required": "You need to accept the trip requirements and terms to book.",
      "not_found": "We couldn't find that tour.",
      "amount_mismatch": "The price changed. Review the total and try again.",
      "payment_failed": "We couldn't process the payment. Try another card.",
      "refund_not_allowed": "The window to cancel with a refund has passed.",
      "refund_failed": "We couldn't process the refund. Please try again.",
      "refund_reconciliation_required": "The refund needs review by the Tago team. Do not pay it again.",
      "split_failed": "We couldn't split the payment. Please try again.",
      "split_not_found": "We couldn't find that payment invite.",
      "split_already_paid": "This share was already paid.",
      "host_required": "Register as a host first.",
      "review_not_allowed": "You can only review a tour you've completed.",
      "review_exists": "You already reviewed this tour.",
      "webhook_invalid": "We couldn't verify the payment.",
      "db_error": "We had a problem saving. Please try again.",
      "internal_error": "Something went wrong on our side. Please try again."
    }
  },
  "screens": {
    "explore": "Explore",
    "vehicle_details": "Vehicle Details",
    "trips": "Trips",
    "trip_details": "Trip Details",
    "messages": "Messages",
    "conversation": "Conversation",
    "hosting": "Hosting",
    "listings": "My Vehicles",
    "earnings": "Earnings",
    "new_listing_details": "Vehicle Details",
    "new_listing_photos": "Photos",
    "new_listing_features": "Features",
    "new_listing_pricing": "Pricing",
    "new_listing_location": "Location",
    "new_listing_review": "Review",
    "hosting_calendar": "Calendar",
    "profile": "Profile",
    "settings": "Settings",
    "verification": "Verification",
    "notifications": "Notifications",
    "payment_methods": "Payment Methods",
    "privacy": "Privacy",
    "data_export": "Export Data",
    "booking": "Booking",
    "insurance": "Insurance",
    "checkout": "Checkout",
    "confirmation": "Confirmation",
    "checkin": "Check-in",
    "checkout_trip": "Check-out",
    "coming_soon": "Coming soon",
    "vehicle_detail": "Vehicle detail",
    "trip_detail": "Trip detail",
    "checkout_checkin": "Check-out"
  },
  "profile": {
    "edit_profile": "Edit Profile",
    "verification": "Verification",
    "payment_methods": "Payment Methods",
    "notifications": "Notifications",
    "privacy": "Privacy & Data",
    "data_export": "Download my data",
    "data_export_subtitle": "Get a copy of all the information on your account",
    "terms_of_service": "Terms of Service",
    "cancellation_policy": "Cancellation Policy",
    "settings": "Settings",
    "logout": "Log Out",
    "logout_confirm_title": "Log Out",
    "logout_confirm_message": "Are you sure you want to log out?",
    "member_since": "Member since {{date}}",
    "profile_completion": "Profile {{percent}}% complete",
    "completion": {
      "see_all": "See {{count}} more",
      "see_less": "See less",
      "field": {
        "first_name": "Add your given names",
        "last_name": "Add your last names",
        "date_of_birth": "Add your date of birth",
        "phone": "Verify your phone",
        "avatar": "Upload a profile photo",
        "verification": "Verify your identity",
        "country": "Set your country",
        "city": "Set your city",
        "language": "Choose your language"
      }
    },
    "date_of_birth": "Date of birth",
    "first_names_placeholder": "e.g. Carlos Eduardo",
    "last_names_placeholder": "e.g. Ávila Renderos",
    "language": "Language",
    "city": "City",
    "select_city": "Choose your city",
    "country": "Country",
    "select_country": "Choose your country",
    "change_avatar": "Change photo",
    "avatar_updated": "Photo updated",
    "avatar_upload_failed": "Could not upload photo",
    "avatar_read_failed": "We couldn't read the photo from your phone. Try another image.",
    "avatar_storage_failed": "We couldn't upload the photo to the server. Check your connection and try again.",
    "avatar_save_failed": "We uploaded the photo but couldn't save it to your profile. Try again.",
    "avatar_session_expired": "Your session expired. Sign out and back in, then try again.",
    "profile_updated": "Profile updated",
    "update_failed": "Could not update profile",
    "imprint": "Legal information",
    "version": "Version {{version}}",
    "validation": {
      "min_age": "You must be at least 18 years old"
    },
    "change_verified_phone": "Change verified phone",
    "phone_not_verified": "No verified phone",
    "phone_verified_hint": "Verified by code. Tap to change it.",
    "phone_add_hint": "Add a number with a security code."
  },
  "imprint": {
    "title": "Legal information",
    "intro": "Tago is the P2P vehicle rental marketplace in El Salvador. We operate as a platform connecting vehicle owners with people who want to rent them.",
    "legal_status_title": "Legal status",
    "legal_status_body": "TAKE AND GO, SOCIEDAD POR ACCIONES SIMPLIFICADA DE CAPITAL VARIABLE (TAGO, S.A.S. DE C.V.), registered with the Commercial Registry of the National Registry Center under entry 152 of book 4942 of the Companies Registry, business registration No. 126, book 512, effective March 10, 2026.",
    "address_title": "Registered office",
    "address_body": "Avenida Jacarandas 175, Colonia Miramonte, San Salvador, El Salvador",
    "contact_title": "Contact",
    "contact_email": "team@tago.rent",
    "contact_whatsapp": "+503 7839 2213",
    "app_version": "App version: {{version}}"
  },
  "legal": {
    "last_updated": "Last updated: {{date}} · v{{version}}"
  },
  "explore": {
    "greeting_morning": "Good morning",
    "greeting_afternoon": "Good afternoon",
    "greeting_evening": "Good evening",
    "search_cta": "Search cars",
    "search_where": "Where",
    "search_placeholder": "Search by model or make (e.g. Vitara)",
    "clear_search": "Clear search",
    "search_start": "From",
    "search_end": "Until",
    "search_date_placeholder": "Choose dates",
    "searching": "Searching cars...",
    "no_results": "No cars match these filters",
    "result_count": "{{count}} cars available",
    "result_count_one": "{{count}} car available",
    "result_count_other": "{{count}} cars available",
    "search_location": "Location",
    "pickup": "Pickup",
    "return": "Return",
    "nearby_title": "Near you",
    "nearby_count": "{{count}} near you",
    "nearby_count_one": "{{count}} near you",
    "nearby_count_other": "{{count}} near you",
    "map_cluster_count": "{{count}} cars",
    "map_cluster_count_one": "{{count}} car",
    "map_cluster_count_other": "{{count}} cars",
    "map_cluster_zoom_label": "{{count}} cars in this area. Tap to zoom in",
    "map_cluster_choose_label": "{{count}} cars. Tap to view the list",
    "map_vehicle_marker_label": "{{vehicle}}, {{price}}",
    "map_cluster_sheet_title": "Cars in this area",
    "nearby_fallback_notice": "No vehicles near you — showing all of El Salvador",
    "nearby_empty": "No vehicles nearby",
    "all_vehicles_empty": "No vehicles available",
    "popular_title": "Popular",
    "view_all": "View all",
    "show_all": "Show all",
    "trip_count": "{{count}} trips",
    "trip_count_one": "{{count}} trip",
    "trip_count_other": "{{count}} trips",
    "rented_days": "{{count}} days rented",
    "rented_days_one": "{{count}} day rented",
    "rented_days_other": "{{count}} days rented",
    "view_map": "View map",
    "map_unavailable": "Map not available",
    "map_unavailable_desc": "We couldn't load the map. The vehicles are still available in the list.",
    "map_unavailable_action": "View the list",
    "trips_this_week": "{{count}} trips completed this week",
    "per_day": "/day",
    "per_hour": "/hr",
    "instant_book": "Instant",
    "promo_title": "15% off",
    "promo_subtitle": "Your first trip",
    "promo_unlock_subtitle": "Complete profile",
    "promo_code": "WELCOME",
    "promo_cta": "Book now",
    "promo_complete_profile_cta": "Complete profile",
    "promo_copied": "Code WELCOME copied. Use it at checkout.",
    "independence_banner_kicker": "September 15 promo",
    "independence_banner_title": "15% off when your trip includes Sep 15",
    "independence_banner_body": "Applied automatically: Tago removes its service fee on bookings that include September 15. No code needed.",
    "independence_banner_accessibility": "September 15 promo. 15 percent off when your trip includes September 15. Applied automatically with no code.",
    "host_cta_title": "Earn money with your vehicle",
    "host_cta_subtitle": "List your vehicle and start earning",
    "default_location": "Choose a place",
    "coming_soon": "Coming soon",
    "notifications": "Notifications",
    "promo_code_label": "Code {{code}} at checkout",
    "promo_locked_label": "Unlocks when your profile is 100% complete.",
    "available_count": "{{count}} available",
    "available_count_one": "{{count}} available",
    "available_count_other": "{{count}} available",
    "filter_title": "Filters",
    "filter_transmission": "Transmission",
    "filter_included_services": "Included",
    "filter_included_services_hint": "Only show vehicles that include these services in the rate.",
    "filter_price_range": "Price range",
    "filter_min_price": "Min price",
    "filter_max_price": "Max price",
    "filter_year": "Min year",
    "filter_instant_book": "Instant book only",
    "filter_apply": "Apply filters",
    "filter_reset": "Clear",
    "filter_active_count": "{{count}} filter(s)",
    "filters_active_notice": "Showing results with {{count}} active filter(s)",
    "location_search_title": "Search location",
    "location_search_placeholder": "Search for a place...",
    "location_no_results": "No results found",
    "location_search_error": "We couldn't search for addresses. Check your connection and try again.",
    "location_close": "Close",
    "date_range_title": "Select dates",
    "date_confirm": "Confirm dates",
    "all_vehicles_title": "All vehicles",
    "map_title": "Map",
    "vehicles_on_map": "{{count}} vehicles",
    "map_view_results_one": "View {{count}} vehicle",
    "map_view_results_other": "View {{count}} vehicles",
    "map_results_title": "Vehicles on the map",
    "map_fit_results": "Fit vehicles on the map",
    "zoom_in": "Zoom in",
    "zoom_out": "Zoom out",
    "vehicles_on_map_one": "{{count}} vehicle",
    "vehicles_on_map_other": "{{count}} vehicles",
    "categories": {
      "suv": "SUV",
      "sedan": "Sedan",
      "pickup": "Pickup",
      "microbus": "Minibus",
      "compact": "Compact",
      "luxury": "Premium",
      "van": "Van",
      "sports": "Electric",
      "heavy_duty": "Work",
      "motorcycle": "Moto",
      "recreational": "Fun"
    },
    "transmission": {
      "automatic": "Auto",
      "manual": "Manual",
      "cvt": "Auto",
      "dct": "Auto"
    },
    "nearby_carousel_dot": "View car {{index}} of {{total}}",
    "rating_new": "New",
    "all_title": "Available in El Salvador",
    "all_count": "{{count}} across the country"
  },
  "welcome": {
    "headline": "Rent your\nnext ride.",
    "slogan": "Your next vehicle, just a tap away.",
    "subheadline": "Verified vehicles from real people, with clear support and included coverage.",
    "cta_start": "Get started",
    "cta_login": "I have an account",
    "divider": "or continue with",
    "divider_short": "or",
    "auth_google": "Google",
    "auth_apple": "Apple",
    "auth_phone": "Phone",
    "auth_email": "Email",
    "legal_prefix": "By continuing, you accept the ",
    "legal_terms": "Terms",
    "legal_and": " and ",
    "legal_privacy": "Privacy",
    "trust_insurance": "Coverage included",
    "trust_verified": "Verified",
    "trust_p2p": "P2P"
  },
  "forgot_password": {
    "headline": "Reset your\npassword.",
    "subtitle": "We'll send you a secure link to set a new password."
  },
  "reset_password": {
    "headline": "Set a new\npassword.",
    "subtitle": "Choose a strong password to protect your account."
  },
  "login": {
    "headline": "Log in",
    "subtitle": "Access your account to book, list, or manage your trips."
  },
  "register": {
    "headline": "Create your\naccount.",
    "subtitle": "Join thousands who rent and share vehicles safely across El Salvador.",
    "strength_weak": "Weak",
    "strength_fair": "Fair",
    "strength_good": "Good",
    "strength_strong": "Strong",
    "email_divider": "or sign up with email"
  },
  "a11y": {
    "hide_password": "Hide password",
    "show_password": "Show password",
    "otp_code": "Verification code",
    "otp_digit": "Digit {{current}} of {{total}}",
    "paste_code": "Long press to paste code",
    "welcome_trust_insurance": "Coverage included",
    "welcome_trust_verified": "Verified vehicles",
    "welcome_trust_p2p": "Peer-to-peer rental",
    "welcome_cta_start": "Start registration",
    "welcome_cta_login": "Go to sign in",
    "welcome_google_hint": "Sign in with Google",
    "welcome_apple_hint": "Sign in with Apple",
    "welcome_phone_hint": "Sign in with phone",
    "welcome_email_hint": "Sign in with email",
    "user_online": "Online",
    "avatar_overflow": "+{{count}} more",
    "clear_search": "Clear search",
    "remove_chip": "Remove",
    "favorite": "Favorite",
    "add_to_favorites": "Add to favorites",
    "remove_from_favorites": "Remove from favorites",
    "vehicle_card_label": "{{make}} {{model}}, ${{price}} per day",
    "rating": "Rating: {{value}} of {{max}} stars",
    "datepicker_prev_month": "Previous month",
    "datepicker_next_month": "Next month",
    "datepicker_prev_year": "Previous year",
    "datepicker_next_year": "Next year",
    "datepicker_select_month": "Select month",
    "datepicker_select_year": "Select year",
    "map_zoom_in": "Zoom in",
    "map_zoom_out": "Zoom out",
    "map_marker": "Map marker",
    "map_canvas": "Map"
  },
  "error": {
    "boundary_title": "Something went wrong",
    "boundary_desc": "An unexpected error occurred. Please try again.",
    "boundary_retry": "Try again"
  },
  "errors": {
    "generic": "Something went wrong. Please try again.",
    "network": "Connection error. Check your internet.",
    "offline_title": "Offline",
    "offline_desc": "Check your internet connection and try again.",
    "offline_action": "Try again",
    "unauthorized": "Your session expired. Please sign in again.",
    "forbidden": "You don't have permission to do that.",
    "bad_request": "The request was invalid. Check your input.",
    "not_found": "We couldn't find what you were looking for.",
    "validation": "Some fields are invalid. Please review the form.",
    "rate_limited": "Too many attempts. Wait a few seconds and try again.",
    "unique_violation": "A record with that data already exists. Try again or contact support.",
    "fk_violation": "Related information is missing. Please try again.",
    "check_violation": "Some fields are invalid. Please review the form.",
    "not_null_violation": "Required fields are missing. Please fill them in.",
    "permission_denied": "You don't have permission to do that.",
    "too_many_connections": "Server is busy. Try again in a few seconds.",
    "timeout": "Server is slow. Try again in a few seconds.",
    "photo_upload_failed": "Photos could not be uploaded. Check the connection and try publishing again.",
    "document_upload_failed": "Could not verify the registration card. Upload clearer photos and try publishing again.",
    "policy_upload_failed": "Could not verify the insurance policy. Upload the complete document and try publishing again.",
    "document_expired": "This document is expired. Please upload a current one."
  },
  "validation": {
    "org_name_min": "Name must be at least 2 characters",
    "org_name_max": "Name cannot exceed 100 characters",
    "org_legal_name_min": "Legal name must be at least 3 characters",
    "org_legal_name_max": "Legal name cannot exceed 200 characters",
    "org_tax_id_required": "Enter the company NIT",
    "org_tax_id_format": "NIT must use the format 0614-050707-104-8",
    "org_tax_id_checksum": "Check the NIT: the verification digit does not match",
    "org_tax_id_max": "NIT cannot exceed 20 characters",
    "email_invalid": "Enter a valid email",
    "phone_min": "Enter at least 8 digits",
    "phone_max": "Phone cannot exceed 15 digits",
    "url_invalid": "Enter a valid URL",
    "email_or_phone_required": "Enter email or phone",
    "payout_bank_required": "Select the bank",
    "payout_account_number_min": "Enter at least 6 digits",
    "payout_account_number_max": "The account number cannot exceed 24 digits",
    "payout_account_number_digits": "Use numbers only",
    "payout_holder_name_min": "The holder name must be at least 3 characters",
    "payout_holder_name_max": "The holder name is too long",
    "payout_dui_format": "The DUI must have 9 digits"
  },
  "toast": {
    "dismiss": "Dismiss",
    "action_undo": "Undo"
  },
  "empty": {
    "no_vehicles_title": "No vehicles yet",
    "no_vehicles_desc": "Add your first vehicle to start hosting",
    "no_vehicles_action": "Add Vehicle",
    "no_bookings_title": "No bookings",
    "no_bookings_desc": "Browse available vehicles to make your first booking",
    "no_bookings_action": "Browse Vehicles",
    "no_messages_title": "No messages",
    "no_messages_desc": "Your conversations will appear here",
    "no_results_title": "No results found",
    "no_results_desc": "No results for \"{{query}}\". Try different keywords.",
    "no_results_desc_generic": "Try adjusting your search or filters.",
    "offline_title": "We could not load this",
    "offline_desc": "Check your connection and try again.",
    "offline_action": "Try again"
  },
  "vehicle_detail": {
    "specs": "Specifications",
    "features": "Features",
    "included_in_rate": "Included in the rate",
    "reviews": "Trips with this vehicle",
    "availability": "Availability",
    "host": "Host",
    "guest": "Guest",
    "book_now": "Book now",
    "per_day": "/day",
    "per_hour": "/hr",
    "no_reviews": "No reviews yet",
    "see_all_reviews": "See all reviews",
    "contact_host": "Contact host",
    "contact_guest": "Contact guest",
    "share": "Share",
    "similar_vehicles": "Similar vehicles",
    "report": "Report",
    "instant_book_badge": "Instant book",
    "view_image": "View image",
    "your_vehicle": "Your vehicle",
    "agency_insurance_coverage": "Commercial coverage from {{orgName}}",
    "host_policy_coverage": "Host’s own policy",
    "qualitas_asr_coverage": "Qualitas coverage verified by ASR",
    "no_platform_coverage": "No platform coverage",
    "platform_insurance_coming_soon": "This vehicle operates under the host's verified policy.",
    "booking_coming_soon": "Coverage included",
    "natural_vehicle_booking_block": "This vehicle is visible while its documents are completed. Booking unlocks once the policy is verified.",
    "unavailable_title": "This vehicle is no longer available",
    "unavailable_body": "It may have been paused, removed, or booked. Keep browsing active vehicles.",
    "browse_available": "View available vehicles",
    "inspection_title": "Mechanical & Safety Inspection",
    "inspection_subtitle": "17 technical check points verified for your safety and peace of mind",
    "inspection_badge": "ASR / Qualitas Verification",
    "inspection_view_photo": "View inspection photo",
    "inspection_slot_hood_open": "Engine bay & open hood",
    "inspection_slot_engine_closeup": "Engine & components",
    "inspection_slot_rim_complete": "Left chassis rail",
    "inspection_slot_rim_serial": "Right chassis rail",
    "inspection_slot_odometer": "Verified odometer",
    "inspection_slot_spare_tire": "Spare tire",
    "inspection_slot_tools": "Emergency tools & jack",
    "inspection_slot_default": "Inspection point"
  },
  "photo_lightbox": {
    "close": "Close",
    "next": "Next photo",
    "previous": "Previous photo",
    "zoom_in": "Zoom in",
    "zoom_out": "Zoom out",
    "counter": "{{current}} of {{total}}",
    "see_all": "See all {{count}} photos"
  },
  "messages": {
    "locked_title": "Chat opens when you book",
    "locked_body": "Once the booking is paid you can message each other right here. That protects your payment and your details.",
    "locked_until_paid": "You can message the host once your booking is paid. That protects both sides.",
    "title": "Messages",
    "search_placeholder": "Search chats",
    "no_conversations": "No chats yet",
    "no_conversations_desc": "The chat with the host opens on its own once your booking is paid. That is where you arrange pickup.",
    "no_results": "No results",
    "no_results_desc": "No conversations matched that name or message.",
    "desktop_empty_title": "Conversations ready",
    "desktop_empty_desc": "Open any chat and pick up where you left off.",
    "empty_conversation_title": "Ready to chat",
    "empty_conversation_desc": "Send the first message whenever you are ready.",
    "type_message": "Type a message...",
    "send": "Send",
    "sending": "Sending",
    "sent": "Sent",
    "read": "Read",
    "jump_to_latest": "Jump to latest",
    "today": "Today",
    "yesterday": "Yesterday",
    "you": "You",
    "image": "Image",
    "open_image": "Open photo",
    "shared_location": "Shared location",
    "open_location": "Open location in maps",
    "attach_title": "Attach",
    "attach_camera": "Take photo",
    "attach_gallery": "Choose from gallery",
    "attach_location": "Share my location",
    "location_permission_denied": "We need location permission to share it.",
    "camera_permission_denied": "We need camera permission to take the photo.",
    "location_unavailable": "We could not get your location. Try again.",
    "quick_replies_label": "Quick replies",
    "quick_reply_on_my_way": "On my way",
    "quick_reply_arrived": "I have arrived",
    "quick_reply_on_time": "I will be there on time",
    "quick_reply_thanks": "Thank you!",
    "call_a11y": "Call {{name}}",
    "call_title": "Call {{name}}",
    "call_body": "Your phone will open to start the call.",
    "call_action": "Call",
    "call_cancel": "Not now",
    "call_unavailable_title": "No phone yet",
    "call_unavailable_body": "{{name}} does not have a verified phone. Keep going in the chat.",
    "call_failed": "The call could not start. Try again.",
    "search_in_conversation": "Search this chat",
    "search_messages_placeholder": "Search messages",
    "search_minimum": "Type at least 2 letters to search this chat.",
    "search_results": "Results",
    "search_no_results_title": "No messages found",
    "search_no_results_desc": "Try another word or phrase.",
    "search_result_a11y": "Search result",
    "close_search": "Close search",
    "reply_action": "Reply",
    "replying_to": "Replying to {{name}}",
    "reply_message": "a message",
    "reply_deleted": "Deleted message",
    "reply_open_original": "View original message",
    "reply_cancel": "Cancel reply",
    "trip_context_title": "Trip",
    "trip_context_open": "View trip",
    "trip_context_pickup": "Pickup",
    "trip_context_dropoff": "Drop-off",
    "system": "System",
    "new_conversation": "New conversation",
    "attach_image": "Attach image",
    "sending_image": "Sending image...",
    "image_too_large": "Image too large",
    "image_send_failed": "Could not send image",
    "send_failed": "Could not send message",
    "send_failed_tap": "Not sent · Tap to retry",
    "retry_send": "Retry sending",
    "content_filtered": "Keep coordination here so you don't lose Tago coverage, payments, or support if something goes wrong.",
    "typing": "{{name}} is typing...",
    "preview_image": "📷 Image",
    "preview_location": "📍 Location"
  },
  "trips": {
    "title": "Trips",
    "upcoming": "Upcoming",
    "past": "Past",
    "all": "All",
    "no_trips": "No trips",
    "no_trips_desc": "When you book a vehicle, your trip will appear here",
    "no_past_trips": "No past trips",
    "no_past_trips_desc": "Trips you have already finished will show up here.",
    "cancel_trip": "Cancel trip",
    "view_details": "View details"
  },
  "cancellation": {
    "title": "Cancellation",
    "confirm_title": "Confirm cancellation",
    "confirm_desc": "This action cannot be undone",
    "reason_label": "Reason for cancellation",
    "reason_placeholder": "Tell us why you're cancelling",
    "reason_plans_changed": "Plans changed",
    "reason_found_alternative": "Found another option",
    "reason_vehicle_issue": "Issue with vehicle",
    "reason_personal": "Personal reason",
    "reason_other": "Other",
    "policy_title": "Cancellation policy",
    "policy_full": "Full refund",
    "policy_full_desc": "100% of the rental back if you cancel more than 48h before pickup",
    "policy_partial": "Partial refund",
    "policy_partial_desc": "50% refund between 24h and 48h before",
    "policy_none": "No refund",
    "policy_none_desc": "No refund within 24h before pickup",
    "refund_summary_title": "Refund summary",
    "refund_line": "Estimated refund",
    "refund_total": "Total returned",
    "refund_amount": "Refund amount",
    "no_refund": "No refund",
    "cancellation_fee": "Cancellation fee",
    "confirm_button": "Confirm cancellation",
    "cancel_button": "Go back",
    "success_title": "Cancellation confirmed",
    "success_desc": "Your booking has been cancelled successfully",
    "refund_status_refunded": "Booking cancelled. The refund was processed.",
    "refund_status_manual_required": "Booking cancelled. The refund is in manual review.",
    "refund_status_not_applicable": "Booking cancelled. No refund applies under the policy.",
    "refund_status_processing": "Booking cancelled. The refund is already processing.",
    "refund_status_pending_reconciliation": "Booking cancelled. We will reconcile the refund.",
    "error_not_cancellable": "This booking cannot be cancelled",
    "error_failed": "Could not cancel the booking",
    "hours_before": "{{hours}}h before pickup",
    "unavailable_title": "This booking is no longer available",
    "unavailable_body": "It may have been cancelled, expired, or moved. Check your active trips.",
    "back_to_trips": "Back to trips"
  },
  "checkin": {
    "add_damage": "Report damage",
    "add_photo": "Add photo",
    "camera_permission_cta": "Enable camera",
    "camera_permission_title": "Camera access is required for the inspection",
    "capture_failed": "The photo could not be taken. Try again.",
    "capture_live_photo": "Capture live photo",
    "condition_excellent": "Excellent",
    "condition_fair": "Fair",
    "condition_good": "Good",
    "condition_poor": "Poor",
    "confirm_checkin": "Confirm check-in",
    "damage_area": "Damage area",
    "damage_description": "Damage description",
    "damages_title": "Existing damages",
    "error_failed": "Could not complete check-in",
    "error_incomplete_body": "Check the steps marked in the list.",
    "error_incomplete_title": "Something is missing",
    "exterior_condition": "Exterior condition",
    "fuel_confirm_hint": "Slide it to where the dashboard needle sits.",
    "fuel_decrease": "Decrease fuel level",
    "fuel_increase": "Increase fuel level",
    "fuel_level": "Fuel level",
    "interior_condition": "Interior condition",
    "license_checking_body": "We're confirming your license is approved before vehicle handoff.",
    "license_checking_title": "Checking license",
    "license_refresh_cta": "I verified my license",
    "license_required_body": "We saved the check-in. If your license is not approved yet, it stays in review before handoff is closed.",
    "license_required_cta": "Verify license",
    "license_required_title": "License pending",
    "license_subtitle": "Take a photo of the license now, at the car. We don't re-verify it: it's the record that they had it on them before driving off.",
    "license_required_for_checkin": "Required to confirm the handover.",
    "license_title": "Guest's driver's license",
    "min_photos_required": "At least {{count}} photos required",
    "missing_required_photos": "Still missing: {{areas}}",
    "notes": "Additional notes",
    "notes_placeholder": "Observations about the vehicle condition",
    "odometer": "Odometer",
    "odometer_placeholder": "Current vehicle km",
    "photo_back": "Back",
    "photo_damage": "Damage",
    "photo_dashboard": "Dashboard",
    "photo_front": "Front",
    "photo_front_left": "Front left",
    "photo_front_right": "Front right",
    "photo_front_seats": "Front seats",
    "photo_left": "Left",
    "photo_license": "License",
    "photo_odometer": "Odometer",
    "photo_optional": "Optional",
    "photo_rear_left": "Rear left",
    "photo_rear_right": "Rear right",
    "photo_rear_seats": "Rear seats",
    "photo_right": "Right",
    "photo_tires": "Tires",
    "photo_trunk": "Trunk",
    "photo_windshield": "Windshield",
    "photos_failed_body": "These did not upload: {{areas}}. Tap the button again — the ones already uploaded are not repeated.",
    "photos_progress": "{{count}}/{{total}} live photos",
    "photos_subtitle": "Six live photos: four angles, interior, and odometer. The odometer shot is required.",
    "photos_title": "Vehicle photos",
    "readiness_title": "Inspection status",
    "ready_title": "Inspection ready",
    "retake_photo": "Retake",
    "subtitle": "Vehicle inspection at pickup",
    "success_desc": "The trip has started. Safe travels!",
    "success_title": "Check-in complete",
    "title": "Check-in",
    "uploading_photos": "Uploading photos"
  },
  "inspection_assurance": {
    "title": "Insurance review",
    "status_pending_submission": "Pending insurer submission",
    "status_submitted": "Received by insurer",
    "status_under_review": "Under review",
    "status_accepted": "Accepted",
    "status_rejected": "Rejected",
    "status_needs_action": "Needs action",
    "status_expired": "SLA expired",
    "status_failed": "Submission failed",
    "review_overdue": "Overdue",
    "due_in_hours": "In {{count}} h"
  },
  "trip_checkout": {
    "title": "Check-out",
    "subtitle": "Vehicle return inspection",
    "comparison_title": "Comparison with check-in",
    "checkin_loading_title": "Loading check-in baseline",
    "checkin_loading_body": "We're loading the pickup inspection so the return can be compared.",
    "checkin_missing_title": "Check-in baseline missing",
    "checkin_missing_body": "We could not find the pickup inspection. Check your connection or open the trip before completing check-out.",
    "checkin_value": "At pickup",
    "checkout_value": "At return",
    "fuel_difference": "Fuel difference",
    "km_driven": "Kilometers driven",
    "new_damage_found": "New damage found",
    "no_new_damage": "No new damages",
    "confirm_checkout": "Confirm check-out",
    "success_title": "Check-out complete",
    "success_desc": "The trip was completed successfully",
    "error_failed": "Could not complete check-out",
    "ready_title": "Check-out ready",
    "odometer_below_checkin": "Odometer must be equal to or greater than {{km}} km.",
    "km_allowance": "Includes {{km}} km for this trip.",
    "extra_km_charge": "Extra km charge",
    "fuel_charge": "Fuel charge",
    "late_return": "Late return",
    "late_fee": "Late return fee",
    "late_notice_title": "Late return",
    "late_notice_body": "{{amount}} is added to the trip for returning {{late}} late.",
    "late_grace_title": "You are inside the grace period",
    "late_grace_body": "No charge until {{time}}. After that, {{amount}} is added.",
    "late_due_title": "The trip is due at {{time}}",
    "late_due_body": "Returning more than {{grace}} late adds {{amount}}."
  },
  "reviews": {
    "title": "Rate your trip",
    "review_trip_cta": "Rate trip",
    "trip_prompt": "How was the trip?",
    "trip_context_guest": "{{vehicle}} · with {{name}}",
    "trip_context_host": "{{name}} · traveled in {{vehicle}}",
    "subtitle": "One rating for the whole experience",
    "overall_rating": "Your experience",
    "tap_to_rate": "Tap to rate",
    "add_comment": "Add a comment",
    "hide_comment": "Hide comment",
    "comment_label": "Comment (optional)",
    "comment_placeholder": "Anything else you’d like to share?",
    "char_count": "{{count}}/{{max}}",
    "submit": "Send",
    "submitting": "Submitting...",
    "success_title": "Review submitted!",
    "success_desc": "Thanks for sharing your experience",
    "error_failed": "Could not submit review",
    "error_not_eligible": "This trip is no longer available for review",
    "error_already_reviewed": "You already reviewed this trip",
    "error_window_closed": "The review period has expired",
    "error_wrong_role": "Only people who took this trip can rate it.",
    "rating_1": "Very bad",
    "rating_2": "Bad",
    "rating_3": "Average",
    "rating_4": "Good",
    "rating_5": "Excellent",
    "no_reviews": "No reviews yet",
    "no_reviews_desc": "Reviews will appear here after completing trips",
    "review_count": "{{count}} review(s)",
    "avg_rating": "Average rating",
    "rating_only": "Left a rating without a comment.",
    "reviewer_fallback": "Tago member",
    "unavailable_title": "This review is no longer available",
    "unavailable_body": "The trip may have changed status or may no longer be available for review.",
    "back_to_trips": "Back to trips"
  },
  "verification": {
    "almost_there_one": "1 step left before you can book",
    "almost_there_other": "{{count}} steps left before you can book",
    "one_time_only": "You only do this once. After that, booking takes two taps.",
    "blocker_identity_review_pending_title": "We are reviewing your documents",
    "blocker_identity_review_pending_desc": "Everything is uploaded. We will let you know as soon as it clears, usually within minutes.",
    "blocker_account_deletion_requested_title": "Your account is being deleted",
    "blocker_account_deletion_requested_desc": "New bookings are paused meanwhile. Write to team@tago.rent if you want to cancel it.",
    "cta_verify_to_book": "Verify to book",
    "title": "Identity verification",
    "subtitle": "Verify your identity for added security",
    "steps_title": "Verification steps",
    "status_pending": "Pending",
    "status_submitted": "In review",
    "status_retry": "In review",
    "status_approved": "Approved",
    "status_rejected": "Rejected",
    "status_expired": "Expired",
    "celebration_title": "You're verified!",
    "celebration_subtitle": "Your identity is confirmed. Complete compliance to book or list.",
    "identity_title": "Identity document",
    "identity_subtitle": "Validate your ID document or passport",
    "identity_manual_title": "Enter the details manually",
    "identity_manual_subtitle": "Fill the fields yourself if automatic reading misses your document",
    "document_type": "Document type",
    "document_type_dui": "DUI",
    "document_type_passport": "Passport",
    "issuing_country": "Document country",
    "issuing_region": "Province or state",
    "issuing_region_placeholder": "Ontario, California…",
    "document_type_national_id": "National ID",
    "document_type_curp": "CURP",
    "document_type_cedula": "Cédula",
    "document_type_driver_license": "Driver's licence",
    "document_number": "Document number",
    "document_number_placeholder": "e.g. 12345678-9",
    "first_name": "Given names",
    "last_name": "Last names",
    "date_of_birth": "Date of birth",
    "issue_date": "Issue date",
    "expiry_date": "Expiry date",
    "front_photo": "Front photo",
    "back_photo": "Back photo",
    "take_photo": "Take photo",
    "scan_document": "Scan document",
    "retake_photo": "Retake",
    "photo_guidelines": "Photo guidelines",
    "photo_guideline_1": "Place document on a flat surface",
    "photo_guideline_2": "Ensure all text is readable",
    "photo_guideline_3": "Avoid glare or shadows",
    "license_title": "Driver's license",
    "license_subtitle": "Upload photos of your personal driver license — not the vehicle registration card.",
    "license_not_tarjeta_hint": "Don't upload the vehicle registration card or DUI. Use the plastic license with your photo and class.",
    "license_retry_subtitle": "We received your license and it is in review.",
    "license_approved_title": "License verified",
    "license_approved_body": "Your driver's license is already approved. You do not need to upload photos again.",
    "license_approved_cta": "Back to verification",
    "license_manual_title": "Enter the details manually",
    "license_manual_subtitle": "Fill the fields yourself if automatic reading misses your license",
    "locked_by_identity": "Verify your identity first",
    "selfie_locked_helper": "Get your ID document or passport approved to unlock this step.",
    "license_locked_helper": "Get your ID document or passport approved to unlock this step.",
    "gate_required_toast": "One more step to continue",
    "gate_required_checklist": "Finish what's missing: contact, ID, license, and selfie. Only once — we never re-ask what you already provided.",
    "license_number": "License number",
    "license_class": "License class",
    "confirm_license_class": "Confirm your license class",
    "license_class_liviana": "Light vehicle",
    "license_class_pesada": "Heavy vehicle",
    "license_class_motocicleta": "Motorcycle",
    "license_class_especial": "Special",
    "sertracen_title": "Official Sertracen check",
    "sertracen_desc": "We use your verified DUI plus the license prefix and control number. TAGO checks Sertracen securely and only approves valid active licenses.",
    "sertracen_prefix": "Prefix",
    "sertracen_control": "Control number",
    "sertracen_control_number": "Control digits",
    "sertracen_control_number_placeholder": "e.g. 003354569",
    "sertracen_open": "Open Sertracen",
    "sertracen_missing_fields": "Enter the license prefix and control number.",
    "sertracen_license_pending": "Confirm the OCR license number first",
    "sertracen_identity_pending": "Confirm your ID document before validating the license.",
    "sertracen_unavailable": "We received your license. If it cannot be confirmed instantly, it stays in review.",
    "front_image": "Front image",
    "back_image": "Back image",
    "selfie_title": "Verification selfie",
    "selfie_subtitle": "Take a selfie to verify your identity",
    "selfie_blocked_title": "Verify your identity first",
    "selfie_blocked_body": "We need to approve your ID document or passport before the selfie step. Takes less than 2 minutes.",
    "go_to_identity": "Go to identity verification",
    "selfie_instructions": "Hold phone at eye level",
    "selfie_take": "Take selfie",
    "submit": "Submit verification",
    "submitting": "Submitting...",
    "success_title": "Verification submitted!",
    "success_desc": "We'll review your information within 24-48 hours",
    "error_failed": "Could not submit verification",
    "verifik_unavailable": "Validation did not respond. Try again with a good connection.",
    "verifik_read_failed": "We could not read the document. Retake the photo with good light, no glare, and the full document inside the frame.",
    "verifik_not_found": "We could not find that {{document}} with that date of birth. Check the details and try again.",
    "verifik_name_mismatch": "The names do not match the document details. Check the details and try again.",
    "verifik_timeout_lookup": "Validation took longer than expected. Try again in a few seconds.",
    "verifik_timeout_reading": "Verifik took too long to read the document. Try again with a clear photo.",
    "verifik_retry_required": "Validation did not finish. Please try again.",
    "identity_processing_notice": "Your verification is still processing. Try again in a few minutes.",
    "identity_in_review_notice": "We received the document. It is in review.",
    "timeout_saved_notice": "Validation took longer than expected and we could not finish it. Your photos are saved — you don't need to take them again.",
    "resume_title": "Your verification was left halfway",
    "resume_desc": "Your photos are saved. You can continue with them or take new ones.",
    "resume_continue": "Continue with my photos",
    "resume_recapture": "Take new photos",
    "license_in_review_notice": "We received the license. It is in review.",
    "selfie_in_review_notice": "We received the verification. It is in review.",
    "error_scan_empty": "We could not read the document. Retake the photo in good light, without glare, with the whole document inside the frame.",
    "rejection_reason": "Rejection reason",
    "web_liveness": {
      "requesting": "Requesting camera permission…",
      "helper": "Look at the camera, position your face inside the oval, and tap Capture. The photo is taken live — file uploads are not allowed.",
      "capture": "Capture",
      "restart": "Restart",
      "retry": "Retry",
      "permission_denied_title": "Camera permission denied",
      "permission_denied_body": "Identity verification needs camera access. Allow the permission in your browser settings or continue from your phone.",
      "no_camera_title": "No camera detected",
      "no_camera_body": "Your browser or device doesn't expose a compatible camera. Try from your phone to complete verification.",
      "error_title": "Could not open the camera",
      "error_body": "Something went wrong starting the camera. Please try again."
    },
    "camera_permission_blocked": "Camera access is blocked for Tago. Enable it in your phone settings and try again.",
    "open_settings": "Open Settings",
    "photo_first_intro": "Take photos of your document and we'll extract the data.",
    "photo_first_intro_web": "Upload photos of your document and we'll extract the data.",
    "dui_lookup_intro": "Take photos of the front and back of your {{document}}. We confirm the details officially afterwards.",
    "dui_lookup_intro_web": "Add photos of the front and back of your {{document}}. We confirm the details officially afterwards.",
    "tap_to_start": "Take front photo",
    "tap_to_capture_back": "Take back photo",
    "upload_front": "Upload front photo",
    "upload_back": "Upload back photo",
    "upload_instruction_front": "Upload a clear photo of the front of your document",
    "upload_instruction_back": "Now upload the back",
    "license_upload_intro": "Upload photos of your license and we'll extract the data.",
    "license_upload_instruction_front": "Upload a clear photo of the front of your license",
    "license_upload_instruction_back": "Now upload the back",
    "front_captured": "Front captured",
    "back_captured": "Back captured",
    "uploading": "Uploading photos...",
    "verifying": "Validating your {{document}}...",
    "verifying_didit": "Verifying your document...",
    "verifying_generic": "Verifying...",
    "dui_lookup_title": "Validate your {{document}}",
    "dui_lookup_subtitle": "Front, back, and official validation in one secure step.",
    "dui_lookup_evidence_title": "{{document}} photos",
    "dui_lookup_evidence_subtitle": "We keep front and back as support for verification, coverage, and claims when applicable.",
    "dui_lookup_front_title": "Front of the {{document}}",
    "dui_lookup_back_title": "Back of the {{document}}",
    "dui_lookup_front_helper": "Full details and photo, no cropping.",
    "dui_lookup_back_helper": "Complete, readable back side.",
    "dui_lookup_take_front": "Take front",
    "dui_lookup_take_back": "Take back",
    "dui_lookup_upload_front": "Add front",
    "dui_lookup_upload_back": "Add back",
    "dui_lookup_retake_front": "Change front",
    "dui_lookup_retake_back": "Change back",
    "dui_lookup_photos_required": "Take a photo of the front and back of your {{document}} to continue.",
    "dui_lookup_missing_title": "Still missing",
    "dui_lookup_missing_front": "The photo of the front of the {{document}}",
    "dui_lookup_missing_back": "The photo of the back of the {{document}}",
    "dui_lookup_missing_number": "The full {{document}} number",
    "dui_lookup_missing_dob": "Your date of birth",
    "dui_number_label": "{{document}} number",
    "dui_lookup_dui_placeholder": "00000000-0",
    "dui_lookup_dob_placeholder": "YYYY-MM-DD",
    "dui_lookup_dob_error": "Use YYYY-MM-DD and an age between 18 and 100.",
    "dui_lookup_cta": "Validate {{document}}",
    "dui_lookup_verifying": "Validating {{document}}...",
    "dui_lookup_checking": "Validating details...",
    "dui_lookup_confirming": "Confirming identity...",
    "dui_lookup_secure_note": "This usually takes a few seconds. Your data is encrypted in transit.",
    "dui_lookup_approved_title": "{{document}} validated",
    "dui_lookup_approved_desc": "Your {{document}} was validated successfully.",
    "uploading_securely": "Uploading photos securely...",
    "verifik_reading_dui": "Reading both sides of the document...",
    "verifik_checking_government": "Confirming identity...",
    "verifik_almost_done": "Still validating. Almost done...",
    "verifik_longer_than_usual": "This is taking longer than usual, but we are still waiting for the secure response.",
    "review_fields": "Review and confirm the details",
    "review_required_fields": "Complete given names, last names, date of birth, and document number before confirming.",
    "confirm_looks_good": "Looks good",
    "retake_front": "Retake front",
    "retake_back": "Retake back",
    "retake_both": "Retake both",
    "result_approved_title": "You're verified!",
    "result_approved_desc": "Your identity was successfully confirmed",
    "result_review_title": "Review the details",
    "result_review_desc": "Confirm or correct the extracted fields",
    "result_declined_title": "We couldn't verify this document",
    "result_declined_desc": "Double-check the number or try a different document",
    "license_manual_review_title": "License received",
    "license_manual_review_body": "It is in review and we will notify you once approved.",
    "license_save_failed": "We couldn't save your license. Check your connection and try again.",
    "try_again": "Try again",
    "use_manual_entry": "I'd rather type the fields",
    "extracted_fields_title": "Extracted data",
    "field_firstName": "Given names",
    "field_lastName": "Last names",
    "field_dateOfBirth": "Date of birth",
    "field_documentNumber": "Document number",
    "field_issueDate": "Issue date",
    "field_expiryDate": "Expiry date",
    "field_firstName_placeholder": "Your given names",
    "field_lastName_placeholder": "Your last names",
    "field_dateOfBirth_placeholder": "YYYY-MM-DD",
    "field_documentNumber_placeholder": "12345678-9",
    "field_issueDate_placeholder": "YYYY-MM-DD",
    "field_expiryDate_placeholder": "YYYY-MM-DD",
    "instruction_front": "Place the front of your document inside the frame",
    "instruction_back": "Now the back",
    "license_photo_first_intro": "Take photos of your driver license (with your photo). Do not use the vehicle registration card.",
    "license_instruction_front": "Place the front of your personal license inside the frame",
    "license_instruction_back": "Now the back of the same license",
    "selfie_photo_first_intro": "Take a selfie to confirm it's you.",
    "selfie_instruction": "Look at the camera in good lighting",
    "selfie_native_hint": "Use good lighting, remove dark glasses, and keep your face inside the frame.",
    "selfie_preparing": "Preparing verification...",
    "selfie_tap_to_start": "Take selfie",
    "selfie_verifying": "Verifying it's you...",
    "selfie_verifying_helper": "Keep the app open. This usually takes a few seconds.",
    "selfie_progress_uploading": "Uploading secure selfie...",
    "selfie_progress_liveness": "Checking liveness...",
    "selfie_progress_face_match": "Matching with your document...",
    "selfie_progress_finishing": "Saving result...",
    "selfie_live_title": "Live biometric verification",
    "selfie_live_body": "Validate your face with a secure liveness check inside Tago.",
    "selfie_live_secure_title": "Protected session",
    "selfie_live_secure_body": "Your verification runs in a protected session without leaving Tago.",
    "selfie_live_start": "Start verification",
    "selfie_web_title": "Continue in the secure provider",
    "selfie_web_body": "On desktop, biometric verification opens in the secure provider window to avoid camera permission blocks. When you finish, return to Tago and check the result.",
    "selfie_web_open": "Open verification",
    "selfie_web_check": "Check result",
    "selfie_live_progress_starting": "Creating secure session...",
    "selfie_live_progress_provider": "Opening live verification...",
    "selfie_live_progress_security": "Checking liveness...",
    "selfie_live_progress_saving": "Confirming result...",
    "selfie_live_approved_body": "Your liveness check was approved and securely saved.",
    "selfie_session_failed": "We could not complete biometric verification. Please try again.",
    "selfie_still_processing": "Verification is still processing. Try again in a few seconds.",
    "selfie_capture_failed": "Could not open the camera. Try again.",
    "selfie_camera_permission_denied": "We need camera permission to verify your selfie.",
    "selfie_upload_failed": "Could not upload the selfie. Check your connection and try again.",
    "selfie_liveness_failed": "We couldn't confirm you're a real person",
    "selfie_match_failed": "Face doesn't match your document",
    "selfie_result_approved": "Selfie verified!",
    "identity_required_for_selfie": "We saved the selfie; it stays in review with your identity.",
    "liveness_label": "Liveness",
    "face_match_label": "Face match",
    "gate_redirecting": "Taking you to the step you still need…",
    "email_subtitle": "For receipts and to recover your access.",
    "phone_subtitle": "Needed to book: it is how the host reaches you.",
    "scanner_unavailable": "We could not open the document scanner on this phone. Try again; if it keeps failing, message us and we will sort it out with you.",
    "selfie_rate_limited": "You made several attempts in a row. Wait about 10 minutes and try again — your progress is not lost.",
    "rate_limited": "Too many verifications in a short time. Wait a moment and try again.",
    "document_type_dni": "DNI",
    "document_type_dpi": "DPI",
    "verifik_not_found_generic": "We could not find that document with that date of birth. Check the details and try again.",
    "dui_lookup_photos_required_generic": "Take a photo of the front and back of your document to continue.",
    "blocked_toast_steps": "You're a few steps away from booking. We'll take you there.",
    "blocked_toast_phone": "Confirm your phone to book. It takes under a minute.",
    "go_do_step": "Do now: {{step}}"
  },
  "payouts": {
    "onboarding_title": "Payout account",
    "onboarding_subtitle": "Save it once and use it to receive your earnings.",
    "onboarding_intro": "We need your bank account to send your earnings. We never store the full number — only the last 4 digits.",
    "secure_title": "Protected details",
    "bank": "Bank",
    "bank_placeholder": "Select your bank",
    "account_type": "Account type",
    "account_savings": "Savings",
    "account_checking": "Checking",
    "account_number": "Account number",
    "account_number_placeholder": "e.g. 12345678901",
    "holder_name": "Account holder name",
    "holder_name_placeholder": "As it appears at the bank",
    "holder_name_org_placeholder": "Exact legal name",
    "document_number": "DUI or tax ID",
    "document_number_placeholder": "12345678-9",
    "document_helper_dui": "Use the DUI of the person who owns the account.",
    "document_helper_org": "The corporate account must match the legal entity name.",
    "review_hint": "Review bank, holder, and account number before saving.",
    "review_hint_selected": "We'll register this account at {{bank}} and store only the masked number.",
    "onboarding_submit": "Save account",
    "onboarding_success": "Account saved. We'll notify you when it's verified.",
    "onboarding_failed": "Could not save the account",
    "title": "Payouts",
    "manage_accounts": "Manage payout accounts",
    "manage_accounts_desc": "Add, edit or switch your bank account",
    "accounts_section": "Your accounts",
    "history_section": "History",
    "no_accounts": "No accounts yet",
    "no_accounts_desc": "Add a bank account to receive your earnings",
    "no_history": "No payouts yet",
    "setup_title": "Set up how you get paid",
    "how_it_works": "How it works",
    "step_account": "You add your bank account",
    "step_account_desc": "We only store the last 4 digits.",
    "step_trip": "You complete a trip",
    "step_trip_desc": "That is when you start earning.",
    "step_deposit": "We deposit your earnings",
    "step_deposit_desc": "We send them within 48 hours after the trip. Every payout shows up in this history.",
    "add_account": "Add account",
    "set_default": "Use as default",
    "default_label": "Default",
    "default_set": "Default account updated",
    "unknown_bank": "Bank",
    "status_pending": "Pending",
    "status_processing": "Processing",
    "status_completed": "Completed",
    "status_failed": "Failed",
    "status_reversed": "Reversed",
    "identity_required_title": "Verify your identity first",
    "identity_required_body": "Before you tell us where to send your money we need to know who you are. It is a one-time step and takes a couple of minutes.",
    "identity_required_action": "Verify identity",
    "identity_source": "From your verified DUI"
  },
  "org_payouts": {
    "title": "Company payouts",
    "subtitle": "Earnings and bank accounts for {{name}}.",
    "onboarding_title": "Bank account",
    "onboarding_subtitle": "Connect the company account to receive payouts smoothly.",
    "onboarding_intro": "The account must match the legal entity name. We store only the last 4 digits.",
    "mtd": "Current month",
    "ytd": "Current year",
    "lifetime": "Lifetime total",
    "rentals": "rentals",
    "pending": "Pending",
    "primary_account": "Company account",
    "configure_cta": "Set up bank account",
    "configure_hint": "Add a company bank account to unlock automatic payouts.",
    "other_accounts": "Other accounts",
    "set_default": "Use as primary",
    "add_account": "Add another account",
    "history": "Payout history",
    "history_empty": "Company payouts will appear here.",
    "col_date": "Date",
    "col_amount": "Amount",
    "col_status": "Status",
    "footnote": "Payouts are sent to {{name}}'s verified primary account.",
    "edit_account": "Edit bank details",
    "status_completed": "Completed",
    "status_processing": "Processing",
    "status_failed": "Failed",
    "status_reversed": "Reversed",
    "status_pending": "Pending",
    "cta_subtitle": "Review accounts, history, and pending payouts."
  },
  "compliance": {
    "delete_title": "Delete account",
    "delete_warning_title": "This action is permanent",
    "delete_warning_desc": "We'll delete your account after 30 days. That grace period is our own choice so you can change your mind — it is not the legal deadline for responding to data requests. Personal data is removed or anonymized; records we are legally required to safekeep (invoicing and commercial relationship records, 10 years) are blocked for authorities instead of deleted.",
    "delete_reason_label": "Reason (optional)",
    "delete_reason_placeholder": "Tell us why you're leaving",
    "delete_request": "Request deletion",
    "delete_confirm_title": "Are you sure?",
    "delete_confirm_desc": "We'll start the 30-day grace period. You can cancel any time during that window.",
    "delete_confirm_yes": "Yes, delete",
    "delete_success": "Request submitted",
    "delete_failed": "Could not submit the request",
    "delete_pending_title": "Deletion scheduled",
    "delete_pending_desc": "Your account will be deleted on {{date}}. You can cancel until then.",
    "delete_cancel": "Cancel deletion",
    "cancel_success": "Deletion cancelled",
    "cancel_failed": "Could not cancel",
    "delete_status_error": "We could not read your account status, so we do not know whether a request is already in progress. Try again before sending one."
  },
  "notifications": {
    "title": "Notifications",
    "empty_title": "You have no notifications",
    "empty_desc": "Updates about your bookings, messages, and more show up here.",
    "mark_all_read": "Mark all as read",
    "mark_all_short": "Mark all"
  },
  "notification_prefs": {
    "title": "Notifications",
    "section_general": "General",
    "push_enabled": "Push notifications",
    "section_trips": "Trips",
    "booking_updates": "Booking updates",
    "trip_reminders": "Trip reminders",
    "section_messages": "Messages",
    "new_messages": "New messages",
    "section_hosting": "Hosting",
    "host_bookings": "New bookings",
    "host_cancellations": "Cancellations",
    "host_payouts": "Payouts",
    "section_promotions": "Promotions",
    "promotions": "Deals & offers",
    "section_delivery": "Delivery method",
    "email_enabled": "Email",
    "sms_enabled": "SMS",
    "push_off_notice": "With push notifications off, every other push alert is paused. Turn them on to choose which ones you receive.",
    "update_failed": "Could not update preference"
  },
  "disputes": {
    "file_title": "Report an issue",
    "file_intro": "Tell us what happened. Your host has 72 hours to respond with their side and evidence. If you don't reach agreement, Tago reviews the case.",
    "detail_title": "Dispute detail",
    "respond_title": "Respond to dispute",
    "respond_claim_summary": "Guest's claim",
    "claim_section": "Claim",
    "response_section": "Response",
    "resolution_section": "Resolution",
    "category_label": "Category",
    "category_vehicle_damage": "Vehicle damage",
    "category_excessive_mileage": "Excess mileage",
    "category_fuel_level": "Fuel level",
    "category_cleanliness": "Cleanliness",
    "category_late_return": "Late return",
    "category_missing_items": "Missing items",
    "category_billing": "Billing",
    "category_other": "Other",
    "description_label": "Description",
    "description_placeholder": "Explain what happened in enough detail that the other party — and Tago, if it comes to that — can understand.",
    "amount_label": "Claim amount (USD)",
    "amount_placeholder": "0.00",
    "amount_claimed": "Amount claimed:",
    "amount_resolved": "Amount resolved:",
    "evidence_label": "Evidence (photos)",
    "evidence_hint": "{{count}} of {{max}} photos.",
    "evidence_source_camera_short": "CAM",
    "evidence_source_library_short": "GAL",
    "add_photo_camera": "Take a photo",
    "add_photo_library": "Pick from library",
    "remove_photo": "Remove photo",
    "submit": "Submit dispute",
    "ready_to_submit": "Ready to submit.",
    "filed_success": "Dispute submitted. We'll let you know when the other party responds.",
    "file_failed": "Could not submit dispute. Try again.",
    "no_response_yet": "No response from the other party yet.",
    "respond_cta": "Respond",
    "response_label": "Your response",
    "response_placeholder": "Tell us your side. Minimum 10 characters.",
    "response_evidence_label": "Evidence (photos)",
    "respond_submit": "Send response",
    "responded_success": "Response sent. Tago will review the case.",
    "respond_failed": "Could not send response. Try again.",
    "deadline_remaining": "Time left:",
    "deadline_expired": "Deadline passed",
    "deadline_expired_explainer": "The 72-hour response window has passed. Tago will review the dispute with the available evidence.",
    "report_damage_cta": "Report a problem with this trip",
    "report_damage_subtitle": "Damage, cleanliness, mileage, fuel, or other.",
    "view_existing_cta": "View open dispute",
    "status_open": "Open",
    "status_awaiting_response": "Awaiting response",
    "status_under_review": "Under review",
    "status_resolved_claimant": "Resolved in your favor",
    "status_resolved_respondent": "Resolved for the other party",
    "status_resolved_split": "Resolved (split)",
    "status_withdrawn": "Withdrawn"
  },
  "error_boundary": {
    "title": "Something went wrong",
    "description": "An unexpected error occurred. Please try again.",
    "action": "Try Again"
  },
  "ui": {
    "search_placeholder": "Search...",
    "search_cancel": "Cancel",
    "select_placeholder": "Select...",
    "select_search": "Search...",
    "select_no_results": "No results",
    "select_date": "Select date",
    "select_month": "Select month",
    "select_time": "Select time",
    "time_period_am": "AM",
    "time_period_pm": "PM",
    "rate_star": "Rate {{count}} stars"
  },
  "settings": {
    "biometric_title": "Biometric unlock",
    "biometric_desc": "Use fingerprint or Face ID to access the app",
    "biometric_toggle_failed": "Could not change biometric unlock",
    "appearance": {
      "title": "Appearance",
      "light": "Light",
      "dark": "Dark",
      "subtitle": "Tago starts in light mode. If you change the appearance, your preference is saved automatically on this device.",
      "light_desc": "Bright interface for daytime use.",
      "dark_desc": "Lower glare for night use.",
      "selected": "Selected",
      "preview_card_heading": "Preview",
      "preview_title": "Toyota Corolla 2022",
      "preview_meta": "San Salvador · Available today",
      "preview_price": "$35/day"
    },
    "safety_section": "Privacy",
    "blocked_users": "Blocked users"
  },
  "block": {
    "action": "Block",
    "unblock_action": "Unblock",
    "confirm_title": "Block {{name}}?",
    "confirm_body": "You will no longer see their vehicles or receive messages from this person. You can unblock them anytime under Settings → Blocked users.",
    "unblock_confirm_title": "Unblock {{name}}?",
    "unblock_confirm_body": "You will see their vehicles again and this person will be able to message you. You can block them again anytime.",
    "reason_label": "Why? (optional)",
    "success_toast": "User blocked",
    "unblock_success_toast": "User unblocked",
    "empty_state": "You haven't blocked anyone.",
    "list_intro": "These users can't contact you and don't appear in your search.",
    "error_generic": "Couldn't complete the action",
    "error_booking": "You can't book this vehicle."
  },
  "hosting": {
    "title": "Hosting",
    "my_listings": "My vehicles",
    "edit_vehicle": "Edit vehicle",
    "edit_overview": "Choose what to change",
    "edit_hint": "Tap Save to apply your changes.",
    "review_changes": "Review changes",
    "edit_exit_title": "Continue later?",
    "edit_exit_body": "Your draft stays on this device. These changes have not been applied to the listing yet.",
    "edit_exit_later": "Continue later",
    "add_vehicle": "Add vehicle",
    "no_listings": "No vehicles listed yet",
    "no_listings_desc": "List your first vehicle and start earning",
    "empty_launch_title": "List your first vehicle",
    "empty_launch_desc": "Photos, documents, and pricing in one simple flow.",
    "empty_step_photos": "Real photos",
    "empty_step_docs": "Registration",
    "empty_step_price": "Pricing",
    "delete_vehicle_title": "Delete vehicle?",
    "vehicle_deleted": "Vehicle deleted",
    "earnings": "Earnings",
    "calendar": "Calendar",
    "status_draft": "Draft",
    "status_pending": "Under review",
    "status_pending_review": "Not published yet",
    "status_active": "Active",
    "status_paused": "Paused",
    "publish_vehicle": "Publish",
    "pause_vehicle": "Pause",
    "continue_listing": "Continue",
    "publish_blocked_draft": "Finish the listing and submit for review to publish it.",
    "publish_blocked_pending_review": "This listing stays off the market until you finish what is missing.",
    "listing_needs_title": "To go live and take bookings, still needed:",
    "blocker_identity": "your approved ID and live selfie",
    "blocker_tarjeta_front": "a current registration-card front",
    "blocker_tarjeta_back": "the registration-card back",
    "blocker_insurance_platform": "Qualitas coverage acceptance",
    "blocker_insurance_own": "a current approved own policy",
    "blocker_photos": "the 17 live ASR photos",
    "blocker_city": "the vehicle city",
    "blocker_location": "the vehicle location",
    "blocker_price": "a valid daily price",
    "blocker_catalog": "a valid make and model",
    "blocker_organization": "your agency to be active and verified",
    "blocker_host_restricted": "contacting support: your account is restricted",
    "blocker_insurance_model": "the vehicle coverage (own policy or platform)",
    "blocker_generic": "a pending requirement",
    "listing_needs_personal_cta": "Finish your verification",
    "listing_needs_docs_cta": "Finish the vehicle documents",
    "expired_doc_title": "Bookings paused",
    "expired_doc_desc": "{{document}} expired on {{date}}. Update it here. Bookings can resume once the document is approved and all other requirements are complete.",
    "expired_doc_cta": "Update",
    "expired_doc_short": "registration or policy expired {{date}}",
    "expired_doc_must_replace": "{{document}} is still expired. Upload the new one to continue.",
    "document_tarjeta_circulacion_front": "The registration card",
    "document_tarjeta_circulacion_back": "The registration card back",
    "document_insurance_policy": "The insurance policy",
    "document_insurance_certificate": "The insurance certificate",
    "document_generic": "A vehicle document",
    "vehicle_published": "Vehicle published",
    "vehicle_pending_review": "We have the listing. It will not appear in the app until you finish what is missing.",
    "vehicle_draft_saved": "Draft saved",
    "vehicle_paused": "Vehicle paused",
    "vehicle_count": "{{count}} vehicle(s)",
    "delete_confirm": "Delete this vehicle?",
    "delete_confirm_desc": "This action cannot be undone",
    "welcome": "Welcome, host",
    "stats_title": "Your summary",
    "total_earnings": "Total earnings",
    "active_listings": "Active listings",
    "pending_bookings": "Pending bookings",
    "active_trips": "Active trips",
    "avg_rating": "Average rating",
    "total_trips": "Completed trips",
    "rented_days": "Days rented",
    "quick_actions": "Quick actions",
    "new_listing": "New vehicle",
    "view_calendar": "View calendar",
    "see_earnings": "View earnings",
    "recent_bookings": "Recent bookings",
    "recent_rentals": "Recent rentals",
    "recent_rentals_subtitle": "Status and next step",
    "recent_rentals_empty": "No recent rentals yet.",
    "no_bookings": "No bookings yet",
    "no_bookings_desc": "When someone books your vehicle, it will appear here",
    "booking_status_pending_payment": "Payment pending",
    "booking_status_awaiting_host": "Waiting for host",
    "booking_status_confirmed": "Confirmed",
    "booking_status_pending_pickup": "Pending pickup",
    "booking_status_active": "In progress",
    "booking_status_pending_return": "Pending return",
    "booking_status_completed": "Completed",
    "booking_status_cancelled": "Cancelled",
    "booking_status_disputed": "Disputed",
    "pending_payouts": "Pending payouts",
    "no_rating": "No rating",
    "coming_soon_title": "Coverage",
    "coming_soon_body": "Individual hosts can now publish with their own verified policy. Platform coverage is live and applies to every trip.",
    "coming_soon_explore": "Explore vehicles",
    "coming_soon_agency": "Create agency profile",
    "coming_soon_agency_label": "Create agency profile",
    "host_onboarding_badge": "Early access",
    "host_onboarding_title": "Publish vehicles on Tago",
    "host_onboarding_subtitle": "Choose how you operate. Agencies and individual hosts can publish with their own verified policy.",
    "host_choice_agency_title": "I am an agency or company",
    "host_choice_agency_body": "Create your legal profile with company name, NIT, and representative to publish your fleet.",
    "host_choice_agency_badge": "Available now",
    "host_choice_agency_label": "Create a legal agency or company profile",
    "host_choice_natural_title": "I am an individual host",
    "host_choice_natural_body": "Upload the front and back of the vehicle registration, plus an active policy or certificate. We verify everything matches the vehicle before publishing.",
    "host_choice_natural_badge": "Available with policy",
    "host_choice_natural_label": "Publish as an individual host with a verified policy",
    "org_loading": "Checking your agency...",
    "org_required_error": "You need a verified host-provided policy before publishing.",
    "exit_draft_title": "Leave this listing?",
    "exit_draft_body": "We save your progress: you can leave and pick up right where you left off.",
    "exit_draft_save": "Save and exit",
    "exit_draft_stay": "Keep editing",
    "draft_autosaved_hint": "We save your progress automatically.",
    "resume_draft_title": "Continue your listing?",
    "resume_draft_body": "Your photos and details are saved. Continue where you left off or discard this draft.",
    "resume_draft_continue": "Continue listing",
    "resume_draft_start_over": "Discard draft",
    "edit_discards_draft_body": "Editing another vehicle deletes the photos and data of the draft you started.",
    "edit_discard_and_edit": "Discard and edit",
    "retention_kicker": "Why stay on Tago",
    "retention_title": "Returning guests pay less. You still collect the listed price.",
    "retention_body": "Tago's fee drops to 8% on the second booking with the same guest and to 5% from the third. Your payout is still the listing subtotal. Coverage, reputation, and 48-hour settlement do not travel to WhatsApp.",
    "retention_point_coverage": "Off Tago, collision and dispute risk sits on your own balance.",
    "retention_point_payout": "We settle to your account within 48 hours. The money does not live in chat.",
    "retention_point_repeat": "When the same guest returns, Tago lowers its commission. You do not subsidize that cut."
  },
  "calendar": {
    "title": "Calendar",
    "available": "Available",
    "blocked": "Blocked",
    "booked": "Booked",
    "reserved": "Reserved",
    "legend": "Legend",
    "block_dates": "Block dates",
    "unblock_dates": "Unblock dates",
    "block_summary": "Block {{range}}",
    "unblock_summary": "Unblock {{range}}",
    "select_dates": "Select dates",
    "instructions": "Tap the first day, then the last. For one day, tap that date. You can switch months without losing your selection.",
    "whole_days_one": "1 full day · El Salvador time",
    "whole_days_other": "{{count}} full days · includes the first and last day",
    "clear_selection": "Clear selection",
    "crosses_reservation": "These dates include a reservation. Choose a range that does not cross reserved days; your selection and the reservation have not been changed.",
    "load_failed": "We couldn't load the calendar",
    "load_failed_body": "We need to check reservations before changing availability. Please try again.",
    "saved_block": "Saved: {{range}} can no longer be booked.",
    "saved_unblock": "Saved: the manual block for {{range}} has been removed.",
    "block_reason": "Reason (optional)",
    "reason_maintenance": "Maintenance",
    "reason_personal": "Personal use",
    "reason_other": "Other",
    "confirm_block": "Confirm block",
    "confirm_unblock": "Confirm unblock",
    "dates_blocked": "Dates blocked",
    "dates_unblocked": "Dates unblocked",
    "no_vehicle_selected": "Select a vehicle",
    "block_failed": "Could not block dates",
    "unblock_failed": "Could not unblock dates",
    "months": "January,February,March,April,May,June,July,August,September,October,November,December",
    "days_short": "M,T,W,T,F,S,S",
    "previous_month": "Previous month",
    "next_month": "Next month"
  },
  "earnings": {
    "title": "Earnings",
    "this_month": "This month",
    "this_week": "This week",
    "all_time": "All time",
    "monthly_breakdown": "Monthly breakdown",
    "per_vehicle": "Per vehicle",
    "pending_payouts": "Pending payouts",
    "transaction_history": "Transaction history",
    "no_earnings": "No earnings yet",
    "no_earnings_desc": "When you complete your first trip, your earnings will appear here",
    "total_rentals": "{{count}} trip(s)",
    "payout_pending": "Payout processing",
    "payout_completed": "Paid"
  },
  "booking": {
    "title": "Book",
    "select_dates": "Select your dates",
    "price_breakdown": "Price breakdown",
    "days": "{{count}} day(s)",
    "daily_rate": "Daily rate",
    "subtotal": "Subtotal",
    "discount": "Discount",
    "cleaning_fee": "Cleaning fee",
    "tago_fee": "Tago service fee",
    "payment_processing": "Payment processing (3.5%)",
    "insurance": "Insurance",
    "protection_included": "Protection included with every trip",
    "protection_coming_soon": "Coverage included",
    "total": "Total",
    "iva": "VAT",
    "iva_included": "VAT not applied for now",
    "security_deposit": "Refundable deposit",
    "security_deposit_note": "It isn't a charge: it's held during the trip. If there's no damage, Tago releases it when the rental is closed.",
    "deposit_held": "Deposit on hold",
    "deposit_held_note": "It isn't a charge. You get it back when the rental closes if there's no damage.",
    "deposit_returning": "Deposit being returned",
    "deposit_returning_note": "We're on it. We'll let you know as soon as it goes out.",
    "deposit_returned": "Deposit returned",
    "deposit_returned_note": "Your bank can take 5 to 10 business days to show it.",
    "deposit_held_host": "Guest's deposit",
    "deposit_held_host_note": "It isn't part of your payout. It goes back to them when the rental closes if there's no damage.",
    "deposit_returning_host": "Deposit being returned",
    "deposit_returning_host_note": "The rental has closed. It's being returned to the guest.",
    "deposit_returned_host": "Deposit returned",
    "deposit_returned_host_note": "It has been returned to the guest.",
    "deposit_claimed": "Kept for damage",
    "deposit_claimed_note": "A resolved dispute assigned this part of the deposit to the host.",
    "deposit_claimed_host": "Assigned to you for damage",
    "deposit_claimed_host_note": "A resolved dispute assigned this part of the deposit to you.",
    "host_earnings": "Host earnings",
    "pickup_location": "Pickup location",
    "dropoff_location": "Dropoff location",
    "pickup_date": "Pickup",
    "pickup_time": "Pickup time",
    "dropoff_date": "Return",
    "dropoff_time": "Return time",
    "select_time": "Select time",
    "pick_times_to_continue": "Pick a pickup and a return time to continue.",
    "pickup_window_hint": "This day, from {{time}}.",
    "dropoff_window_hint": "This day, until {{time}}.",
    "time_slot_unavailable": "{{time}}, not available this day",
    "time_window_empty": "This day has no free time. Pick another one.",
    "start_in_the_past": "That pickup time is already in the past. Choose the first free hour.",
    "minimum_duration_notice": "This car has a minimum booking length of {{count}} days.",
    "minimum_duration_error": "Adjust the return date or time: this car requires at least {{count}} days.",
    "same_location": "Same return location",
    "different_location": "Different return location",
    "select_insurance": "Reservation coverage",
    "promo_code": "Promo code",
    "apply_promo": "Apply",
    "promo_applied": "Code applied",
    "promo_invalid": "Invalid code",
    "promo_code_not_found": "Code not found",
    "promo_expired": "This code has expired",
    "promo_max_uses_reached": "This code has reached its usage limit",
    "promo_user_limit_reached": "You have already used this code",
    "promo_not_first_rental": "This code is for first-time renters only",
    "promo_user_not_eligible": "This code is not available for your profile.",
    "promo_below_minimum": "Rental amount is below the minimum for this code",
    "promo_not_yet_valid": "This code is not yet active",
    "promo_country_not_eligible": "This code is not valid for your country.",
    "promo_profile_incomplete": "Complete your profile to 100% to use this code.",
    "independence_promo_applied": "Your booking includes September 15: Tago automatically removes its service fee (15%).",
    "independence_discount": "September 15 promo",
    "confirm_booking": "Confirm booking",
    "agency_only_error": "For now, you can only book vehicles with a verified host-provided policy.",
    "errors": {
      "unavailable": "This vehicle is not available for the selected dates",
      "min_days": "Minimum duration is {{hours}} hours",
      "max_days": "Maximum duration is {{days}} days",
      "own_vehicle": "You cannot book your own vehicle",
      "dates_blocked": "Vehicle is blocked for these dates",
      "create_failed": "Could not create booking",
      "cancel_failed": "Could not cancel booking"
    },
    "availability_loading": "Checking which days are free...",
    "availability_error_title": "We couldn't load availability",
    "availability_error_body": "Without it we can't tell which days are free. Check your connection and try again.",
    "return_crosses_unavailable": "That range includes days when the vehicle is already booked. Pick an earlier return date.",
    "return_unavailable_title": "No return date available",
    "return_unavailable_body": "The vehicle is already booked on the days right after that pickup date, so no valid range is left. Pick a different pickup date.",
    "dates_cleared_unavailable": "Those dates are no longer available. Select your dates again.",
    "charged_today": "Charged today",
    "trip_total": "Trip total"
  },
  "insurance": {
    "title": "Trip coverage",
    "provider_name": "Insurance partner",
    "provider_short": "Insurance partner",
    "provider_short_coming_soon": "Coverage included",
    "provider_short_included_soon": "Coverage included",
    "provider_tagline": "Trip coverage",
    "provider_view_coverage_soon": "Coverage details",
    "provider_logo_alt": "Coverage icon",
    "launching_soon": "Included in every trip",
    "provider_launching_soon_a11y": "Coverage for trips, included",
    "provider_partner_context": "Backed by",
    "provider_partner_review_a11y": "Backed by Quálitas.",
    "coming_soon_badge": "Included",
    "available_soon": "Included in your booking",
    "early_access_desc": "One included coverage. No plans to choose.",
    "included_title": "Trip coverage",
    "included_soon_badge": "Included",
    "included_desc": "Integrated as one coverage included in the booking: a per-day premium, with no plans or surprise charges.",
    "included_point_auto": "Applies automatically to every trip.",
    "included_point_no_plans": "No plan selection or extra setup.",
    "included_point_assistance": "24/7 assistance included in El Salvador.",
    "included_point_benefits": "A policy issued for your trip before confirmation.",
    "assistance_card_title": "Assistance desk",
    "assistance_card_desc": "Available for trips with active coverage. Use these numbers if you need help during the trip.",
    "assistance_card_a11y": "Coverage assistance desk",
    "assistance_generic_title": "Assistance",
    "assistance_generic_desc": "Open the dialer with the assistance line number for trips with active coverage.",
    "assistance_generic_badge": "Contact",
    "assistance_call": "Call {{phone}}",
    "assistance_call_now": "Call now",
    "assistance_call_primary": "Call assistance at {{phone}}",
    "assistance_call_secondary": "Call alternate number {{phone}}",
    "assistance_secondary_short": "Other number: {{phone}}",
    "assistance_phone_ready": "The dialer will open with {{phone}} ready to call.",
    "assistance_call_failed": "We could not open the dialer. Call the displayed number manually.",
    "current_policy_note": "Agency vehicles and those without platform coverage operate under the host's verified policy.",
    "provider_partner_live_title": "Every trip backed",
    "provider_partner_live_a11y": "Every trip backed by Quálitas, with a policy."
  },
  "checkout": {
    "title": "Checkout",
    "your_trip": "Your trip",
    "summary": "Booking summary",
    "payment_method": "Payment method",
    "select_payment": "Select a payment method",
    "confirm": "Confirm and pay",
    "or": "or",
    "pay_now": "Pay now",
    "pay_securely": "Pay {{amount}} securely",
    "pay_securely_a11y": "Pay securely",
    "pay_with_new_card": "Use another card",
    "paypal": "PayPal",
    "paypal_title": "Pay with PayPal",
    "paypal_desc": "Use your PayPal account without sharing your card details with Tago.",
    "paypal_secure_title": "Secure payment with PayPal",
    "paypal_secure_desc": "PayPal protects your payment details. Tago only receives the order confirmation.",
    "paypal_secure_note": "PayPal will open securely. When you finish, you'll return to Tago automatically.",
    "paypal_pending": "Your PayPal order is ready. Complete the authorization to confirm your booking.",
    "paypal_continue": "Continue in PayPal",
    "pay_with_paypal": "Pay {{amount}} with PayPal",
    "paypal_fee_line": "PayPal processing",
    "processor_fee_hint": "PayPal's fee is added to your total. Tago does not absorb it.",
    "secure_payment_title": "Secure payment",
    "secure_payment_desc": "Your payment details stay with the processor. Tago only keeps a safe reference so you can recognize your cards.",
    "saved_cards_title": "Your cards",
    "saved_cards_desc": "Choose a saved card or use another card.",
    "saved_card_cvv_desc": "The processor may ask for CVV to confirm this payment. It is not stored after sending.",
    "saved_card_cvv_label": "Saved card CVV",
    "card": "Card",
    "card_expiry": "Expires {{expiry}}",
    "other_methods": "Other payment methods",
    "other_methods_desc": "Puntos Agrícola, Bitcoin, Installments",
    "cancellation_policy": "Cancellation policy",
    "cancellation_full": "Full rental refund up to 48h before",
    "cancellation_partial": "50% refund between 24h and 48h before",
    "cancellation_none": "No refund within 24h before",
    "cancellation_fee_note": "Tago's service fee is not refunded when you cancel.",
    "terms": "By confirming, you accept the rental terms and cancellation policy",
    "accept_terms_error": "Accept the terms to continue.",
    "missing_booking_data": "Review the dates and vehicle before reserving.",
    "start_in_the_past": "That pickup time is already in the past. Go back and choose the first free hour.",
    "dates_unavailable": "That vehicle is already reserved for those dates. Choose other dates.",
    "vehicle_no_longer_available": "This vehicle is no longer available. Go back to explore and choose an active one.",
    "vehicle_document_expired": "This vehicle has an expired document and cannot be booked. Choose another while the host renews the papers.",
    "dates_blocked": "The host blocked those dates. Choose other dates.",
    "min_rental_duration": "This car has a minimum booking length. Adjust your dates to continue.",
    "processing": "Processing payment...",
    "platform_insurance_coming_soon": "This vehicle operates under the host's verified policy.",
    "delivery_return_title": "Delivery and return",
    "pickup_at": "Delivery",
    "dropoff_at": "Return",
    "delivery_radius_notice": "Available up to {{radius}} km from the host point.",
    "vehicle_location_missing_title": "Delivery point missing",
    "vehicle_location_missing": "This vehicle does not have a delivery point configured yet. Choose another vehicle while the host fixes it.",
    "location_out_of_radius": "Delivery or return is outside the radius allowed by the host.",
    "pickup_location_title": "Pickup point",
    "dropoff_location_title": "Return point",
    "search_or_drag_pin": "Search an address or move the map pin.",
    "location_search_placeholder": "Search address",
    "location_no_results": "No addresses matched that search.",
    "selected_location": "Selected location",
    "location_within_radius": "{{distance}} km from the host point. Max radius: {{radius}} km.",
    "location_out_of_radius_detail": "{{distance}} km from the host point. Maximum allowed: {{radius}} km.",
    "save_location": "Save location",
    "same_return_location": "Return at the same pickup point",
    "resume_loading_title": "Recovering pending payment",
    "resume_loading": "We're loading the pending booking so you can continue payment.",
    "resume_error_title": "Could not recover payment",
    "resume_error": "We could not load that pending booking. Open it again from your trips.",
    "resume_already_handled_title": "Booking already updated",
    "resume_already_handled": "This booking is no longer pending payment. Check your trips for the current status.",
    "resume_saved_locations": "Locations saved on this booking.",
    "pair_fee_loading": "We're calculating your service fee for this host."
  },
  "payment": {
    "title": "Payment",
    "processing": "Processing payment...",
    "redirecting": "Preparing your payment confirmation...",
    "redirecting_paypal": "Returning from PayPal...",
    "success": "Payment successful!",
    "success_desc": "Your booking has been confirmed. We'll send you an email with the details.",
    "failed": "Payment declined",
    "failed_desc": "The payment was not processed. Try again or use a different payment method.",
    "wompi_generic_validation": "The processor could not validate that charge. Nothing was taken. Try again or use another card.",
    "declined_title": "The card did not go through",
    "declined_desc": "The bank declined this charge. Nothing was taken. Try again or use another card.",
    "validation_title": "We could not validate the charge",
    "validation": "The processor could not validate that charge. Nothing was taken. Try again or use another card.",
    "app_not_live_title": "This merchant is not live yet",
    "app_not_live": "The payment processor has not taken this merchant live. It is not your card.",
    "challenge_abandoned_title": "You left bank verification",
    "challenge_abandoned": "You left bank verification. Nothing was taken. You can try again.",
    "start_in_past_title": "That pickup time has passed",
    "booking_too_soon_title": "Pick a later start",
    "booking_too_soon": "Choose a start at least three hours from now.",
    "create_failed_title": "We could not start the charge",
    "total_mismatch_title": "The price changed",
    "saved_card_title": "Saved card unavailable",
    "hosted_checkout_title": "Hosted checkout did not open",
    "hosted_checkout_could_not_start": "We could not open hosted checkout. Nothing was taken. Try again in a moment.",
    "unconfirmed_title": "We couldn't confirm your payment",
    "unconfirmed_desc": "The bank hasn't answered yet, so we don't know whether the charge went through. Don't try again: if it was approved, the booking will appear in My trips within a few minutes and we'll notify you as soon as it's confirmed.",
    "unconfirmed_action": "View my trips",
    "processing_delayed": "Your payment is being processed. We'll notify you when it's confirmed.",
    "timeout": "Payment time expired",
    "retry": "Retry payment",
    "bank_verification": "Bank verification",
    "loading_verification": "Loading verification...",
    "cancel_verification_title": "Cancel verification?",
    "cancel_verification_desc": "If you cancel, the payment may still have been processed. Check your bank statement.",
    "complete_payment": "Complete payment",
    "rental_no_longer_active": "The booking was no longer active when the charge was approved. We returned your money; check your trips before booking again.",
    "total_mismatch": "The price of this booking changed. Go back to the booking to see the updated amount.",
    "refunded_title": "We returned your money",
    "refunded_desc": "The charge was approved after the booking had already been cancelled, so we reversed it. No trip took place and you were not charged.",
    "refund_pending_desc": "The charge was approved after the booking had already been cancelled. We're processing the refund and will let you know as soon as it's done.",
    "cancelled_title": "Payment cancelled",
    "cancelled_desc": "You were not charged. You can return to PayPal when you're ready to confirm the booking.",
    "booking_blocked_title": "One step left before paying",
    "booking_blocked_unknown": "We could not determine what is missing. Open Verification in your profile.",
    "booking_blocked_cta": "Complete now",
    "blocker_identity_review_pending": "Your documents are approved; we are finishing enabling you",
    "blocker_account_deletion_requested": "You asked to delete your account. Contact us to restore it.",
    "blocker_unknown_profile": "We could not find your profile. Please sign in again.",
    "saved_card_unavailable": "We can't charge saved cards right now. Use the card form below.",
    "bank_verification_unavailable": "We couldn't start the bank verification. It isn't your card — try again in a bit.",
    "wompi_app_not_live": "Wompi has not put this app live yet. It isn't your card — in the dashboard turn En Vivo on for the test aplicativo.",
    "could_not_start": "We couldn't start the charge and nothing was charged. Try again in a bit.",
    "paypal_could_not_start": "We couldn't open PayPal",
    "paypal_could_not_start_desc": "You were not charged. Try again in a moment."
  },
  "card_form": {
    "card_number": "Card number",
    "expiry": "Expiry",
    "cvv": "CVV",
    "cardholder_name": "Cardholder name",
    "cardholder_name_placeholder": "e.g. Carlos Ávila",
    "pay_amount": "Pay {{amount}}",
    "card_required": "Enter card number",
    "invalid_card": "Invalid card number",
    "expiry_required": "Enter expiry date",
    "invalid_expiry": "Invalid expiry date",
    "card_expired": "Card is expired",
    "cvv_required": "Enter CVV",
    "invalid_cvv": "Invalid CVV"
  },
  "confirmation": {
    "title": "Booking confirmed!",
    "subtitle": "Your booking was created successfully",
    "reference": "Booking code",
    "vehicle": "Vehicle",
    "dates": "Dates",
    "host": "Host",
    "total_paid": "Total paid",
    "view_trips": "View my trips",
    "contact_host": "Contact host",
    "what_next": "What's next?",
    "next_step_1": "We've let the host know",
    "next_step_2": "Message them to arrange pickup",
    "next_step_3": "Present your ID when picking up the vehicle"
  },
  "rental_terms_flow": {
    "title": "Rental terms · v{{version}}",
    "loading_title": "Booking terms",
    "loading": "Loading the current version…",
    "unavailable": "We couldn't verify the current version. We won't charge you until you can review it.",
    "retry": "Try again",
    "read_terms": "Read full terms",
    "read_cancellation": "View cancellations and refunds",
    "profile_current_version": "The current version is {{version}}. We'll open its complete permanent document; your earlier bookings keep their original terms.",
    "open_current_document": "Open current document",
    "open_error": "We couldn't open the document. Please try again.",
    "payment_disclosure": "You pay now. The host has 2 hours to accept or decline; until then your booking is not confirmed. If they decline or the deadline passes, we arrange a full refund.",
    "minimum_lead_title": "Choose a later pickup",
    "minimum_lead": "To give the host the full 2 hours to respond, choose a pickup at least 3 hours from now. No charge was attempted.",
    "accept_label": "I have read version {{version}} of both documents and accept its terms for this booking.",
    "changed": "The terms changed. Review the new version before paying.",
    "stale_hold_title": "Start with the current terms",
    "stale_hold_body": "This unpaid request was created under an older version. We won't start another charge under those terms. Starting over safely closes the earlier attempt so you can review the current terms.",
    "restart": "Start a new request",
    "restart_ready": "The earlier request is closed. Review the current terms to continue.",
    "restart_failed": "We couldn't safely close the earlier attempt. Check your trips before trying to pay again.",
    "host_title": "Review the updated terms",
    "host_body": "To receive new paid requests, review and accept the current version. Your older bookings and response deadlines are unchanged.",
    "host_upcoming_title": "Get ready for updated terms",
    "host_upcoming_body": "An announced version is not yet in effect. You can read and accept it now so new requests continue without interruption when it takes effect. Existing bookings stay unchanged.",
    "host_accept": "Accept updated terms",
    "host_accept_upcoming": "Accept announced version",
    "host_accepted": "Terms accepted",
    "host_error": "We couldn't save your acceptance. Please try again.",
    "host_unavailable": "This host hasn't accepted the updated terms yet. We won't charge for this vehicle; choose another or try later."
  },
  "host_approval": {
    "payment_received": "Payment received",
    "waiting_title": "Waiting for the host",
    "waiting_subtitle": "You've paid. Your booking is confirmed once the host accepts it.",
    "deadline": "Respond by {{time}}",
    "guest_deadline": "The host will respond by {{time}}",
    "time_remaining": "{{minutes}} min left to respond",
    "host_title": "You have a paid booking request",
    "host_body": "Accept or decline before the deadline. If you don't respond, we'll initiate a full refund for the guest.",
    "guest_body": "The host has up to 2 hours. We'll notify you when they respond; if they can't accept, we'll arrange a full refund.",
    "accept": "Accept booking",
    "decline": "I can't host",
    "decline_title": "Can't host this booking?",
    "decline_body": "We'll cancel the request and arrange a full refund for the guest.",
    "decline_body_v2": "We'll cancel this request and arrange a full guest refund. Confirmed-booking penalties do not apply. If Wompi keeps a processing fee, we'll send you the amount and evidence; you'll have 7 days to dispute it before any future payout offset.",
    "keep_request": "Keep booking",
    "decline_confirm": "Decline and refund",
    "accepted": "Booking accepted",
    "declined": "Booking cancelled. The refund is being arranged.",
    "expired": "The deadline has passed. Refresh to see the latest status.",
    "error": "We couldn't save your response. Check the status and try again."
  },
  "host_gateway_fee": {
    "title": "Processing cost",
    "load_error": "We couldn't load this charge. No payout offset is made from this screen.",
    "status_notice_period": "Wompi retained this cost after the full guest refund. It has not been taken from any payout.",
    "status_disputed": "We received your dispute. The charge is on hold while we review the evidence.",
    "status_approved": "The review is complete. This cost may be offset against a future payout to the same account.",
    "partially_applied": "Already offset: {{applied}} · Remaining balance: {{pending}}",
    "status_applied": "This cost has already been included in a payout to the same account.",
    "status_waived": "We waived this charge. It will not be deducted from any payout.",
    "breakdown": "Wompi fee: {{gross}} · Credit or reversal: −{{credit}}",
    "reference": "Statement reference: {{reference}}",
    "dispute_until": "You can dispute this until {{date}}. It will not be deducted before then.",
    "dispute": "Dispute this cost",
    "reason_label": "Reason for your dispute",
    "reason_placeholder": "Tell us what doesn't match. We'll review the statement and reply.",
    "send_dispute": "Send dispute",
    "dispute_saved": "We received your dispute. The charge is on hold.",
    "dispute_error": "We couldn't save your dispute. Don't assume it was sent; retry or email us.",
    "request_statement": "Request the statement",
    "statement_error": "We couldn't open your email app. Write to teamtagorent@gmail.com with your booking reference."
  },
  "listing": {
    "wizard_title": "New vehicle",
    "edit_load_failed_title": "We couldn't open this vehicle",
    "edit_load_failed_body": "Nothing in your listing changed. Try again, or go back to your vehicles.",
    "step_details": "Details",
    "step_ownership": "Ownership",
    "ownership_title": "Whose car is this?",
    "ownership_subtitle": "We need this for your coverage and to confirm you can list it.",
    "ownership_mine_title": "It's mine",
    "ownership_mine_desc": "It's registered in my name on the circulation card.",
    "ownership_third_party_title": "It's someone else's",
    "ownership_third_party_desc": "A relative, a friend, or my employer — with their permission.",
    "ownership_company_title": "It belongs to a company",
    "ownership_company_desc": "It's registered to a company I'm part of.",
    "ownership_not_declared": "Not declared yet — tap Edit to answer.",
    "ownership_authorizer_label": "Whose name is it under?",
    "ownership_authorizer_placeholder": "Owner's name",
    "ownership_authorizer_hint": "It must match the circulation card. We'll confirm your authorization later.",
    "ownership_mismatch_body": "The card's owner doesn't match your name. Is it someone else's?",
    "ownership_mismatch_switch": "It's someone else's",
    "ownership_switched_third_party": "Switched to someone else's. You'll need their authorization.",
    "publish_saved_as_draft": "Saved as a draft. Finish your verification to publish it.",
    "publish_confirming": "Everything is saved. We're finishing the publish — check My vehicles in a moment.",
    "tarjeta_expired": "Your circulation card expired on {{date}}. Renew it at sertracen.com.sv, at a Sertracen kiosk or an authorised bank (it takes minutes, plus a $5.71 late fee per year) and scan it again here. Everything else is saved.",
    "photo_upload_forbidden": "We couldn't upload the photo: looks like a permission or session issue. Sign out, sign back in, and try again.",
    "photo_upload_network": "We couldn't upload the photo. Check your connection and try again.",
    "step_features": "Features",
    "step_photos": "Photos",
    "photo_pick_failed": "We couldn't open your gallery. Check permissions and try again.",
    "photos_live_title": "Live initial inspection",
    "photos_live_subtitle": "Capture the {{count}} shots with Tago's camera. Each photo is tied to a requirement; gallery photos are not accepted.",
    "capture_live_photo": "Capture live photo",
    "retake_live_photo": "Retake live photo",
    "extra_photos_title": "Additional photos (optional)",
    "extra_photos_help": "Got a 360 camera, a 4x4 selector or other extras that don't fit in a single shot? Add as many photos as you like. These are not required.",
    "extra_photos_add": "Add photo",
    "photos_missing_summary": "{{missing}} shots still missing: {{list}}",
    "photos_missing_count": "{{missing}} inspection shots are still missing. They're marked in red below.",
    "photos_upfront_notice": "You'll need {{total}} live photos of the vehicle taken with Tago's camera. Have it with you before you start.",
    "insurance_redirect_a11y": "Opening the documents step",
    "live_document_helper": "Place the full document inside the frame and capture it live.",
    "photo_requirements": {
      "front_right": "Front and right side",
      "front_left": "Front and left side",
      "hood_open": "Full engine bay",
      "engine_closeup": "Chassis number",
      "rear_right": "Rear and right side",
      "rear_left": "Rear and left side",
      "trunk_panorama": "Trunk panorama",
      "spare_tire": "Spare tire",
      "tools": "Tools",
      "rim_complete": "Left longeron and chassis",
      "rim_serial": "Right longeron and chassis",
      "dashboard_panorama": "Console, radio and wheel",
      "dashboard_on": "Dashboard powered on",
      "odometer": "Odometer",
      "front_seats": "Front seats",
      "exterior_accessories": "Roof and exterior accessories",
      "interior_accessories": "Console and interior accessories"
    },
    "photo_requirement_hints": {
      "front_right": "Capture the front with the right side visible.",
      "front_left": "Capture the front with the left side visible.",
      "hood_open": "Open the hood and capture engine, covers, hoses, and visible bodywork.",
      "engine_closeup": "Move close enough for the chassis number to be readable.",
      "rear_right": "Show the rear and right side.",
      "rear_left": "Show the rear and left side.",
      "trunk_panorama": "Open the trunk and capture the whole space.",
      "spare_tire": "Show the full spare tire.",
      "tools": "Show jack, wrench, and included tools.",
      "rim_complete": "Show the left longeron and chassis from the engine bay.",
      "rim_serial": "Show the right longeron and chassis from the engine bay.",
      "dashboard_panorama": "Show center console, radio, and steering wheel.",
      "dashboard_on": "Turn the vehicle on and show indicators/lights.",
      "odometer": "Move close to the mileage reading.",
      "front_seats": "Show both front seats.",
      "exterior_accessories": "Show the whole roof with sunroof, bars, or steps. If it has none, take the roof anyway.",
      "interior_accessories": "Show the console with camera, screen, or subwoofer. If it has none, take the console anyway."
    },
    "step_location": "Location",
    "step_pricing": "Pricing",
    "step_insurance": "Insurance",
    "step_review": "Review",
    "step_of": "Step {{current}} of {{total}}",
    "next": "Next",
    "next_with_count": "Next ({{current}}/{{total}})",
    "previous": "Previous",
    "publish": "Publish",
    "save_draft": "Save draft",
    "submit_for_review": "Send to review",
    "submit_phase_saving": "Saving details...",
    "submit_phase_photos": "Uploading photos...",
    "submit_phase_photos_progress": "Uploading photos {{completed}}/{{total}}",
    "submit_phase_documents": "Checking documents...",
    "submit_phase_coverage": "Sending coverage review...",
    "submit_phase_publishing": "Publishing...",
    "submit_timeout_location": "The connection took too long while checking the location. We continued with the address you entered.",
    "submit_timeout_saving": "Saving did not finish in time. Check your connection and try again.",
    "submit_timeout_photos": "Photo upload did not finish in time. Check your connection and try again.",
    "submit_timeout_documents": "Document upload did not finish in time. Check your connection and try again.",
    "submit_timeout_coverage": "Coverage review did not finish in time. Check your connection and try again.",
    "submit_timeout_publishing": "Publishing confirmation did not finish in time. We are taking you to the dashboard to show the real status.",
    "coverage_review_submit_failed": "We could not send the coverage review. Please try again.",
    "make": "Make",
    "make_placeholder": "Select make",
    "model": "Model",
    "model_placeholder": "Select model",
    "year": "Year",
    "year_placeholder": "Select year",
    "year_hint": "For now we accept vehicles from {{year}} onward.",
    "category": "Category",
    "color": "Color",
    "color_placeholder": "e.g. White, Black, Gray",
    "transmission": "Transmission",
    "fuel_type": "Fuel type",
    "seats": "Seats",
    "doors": "Doors",
    "plate_number": "Plate number",
    "plate_placeholder": "e.g. P123456",
    "title": "Listing title",
    "title_placeholder": "e.g. Toyota Corolla 2023 - Automatic",
    "description": "Description",
    "description_placeholder": "Describe your vehicle, condition, and what makes it special",
    "features_label": "Features",
    "features_hint": "Select only what the vehicle has.",
    "instant_book": "Instant booking",
    "instant_book_desc": "Guests can book without prior approval",
    "daily_rate": "Daily rate (USD)",
    "security_deposit": "Security deposit (optional)",
    "security_deposit_placeholder": "0.00",
    "security_deposit_help": "The guest is charged and Tago holds it; if there is no damage, Tago releases it when the rental is closed. A ~3.5% processing fee is deducted from you when it is returned. Best for high-value vehicles.",
    "daily_rate_placeholder": "25.00",
    "min_rental_duration": "Minimum duration",
    "min_rental_duration_desc": "Choose whether to avoid very short bookings. The calendar will only allow dates that satisfy this rule.",
    "min_rental_none": "No minimum",
    "min_rental_none_desc": "Accept any available trip.",
    "min_rental_2_days": "2 days",
    "min_rental_2_days_desc": "Balanced: less turnover without limiting too much.",
    "min_rental_3_days": "3 days",
    "min_rental_3_days_desc": "Best for longer trips and fewer handoffs.",
    "hourly_rate": "Hourly rate (USD)",
    "weekly_discount": "Weekly discount (%)",
    "monthly_discount": "Monthly discount (%)",
    "cleaning_fee": "Cleaning fee (USD)",
    "km_limit": "Daily km limit",
    "km_unlimited": "No limit",
    "km_hint": "Leave empty for unlimited kilometers",
    "excess_km_rate": "Excess km rate",
    "insurance_model": "Insurance model",
    "insurance_models": {
      "platform": "Platform",
      "fleet": "Fleet",
      "hybrid": "Hybrid",
      "none": "No insurance"
    },
    "insurance_platform": "Platform",
    "insurance_fleet": "Fleet",
    "insurance_hybrid": "Hybrid",
    "insurance_none": "None",
    "insurance_title": "Listing insurance",
    "insurance_locked_notice": "Listings still require a verified host-provided policy; coverage will be integrated as included booking coverage.",
    "insurance_agency_title": "Host-provided policy",
    "insurance_agency_desc": "Upload an active policy or certificate for this vehicle. We verify identity, dates, and coverage before publishing.",
    "insurance_agency_selected": "Required to publish now",
    "insurance_partner_title": "Coverage included",
    "insurance_partner_badge": "Included",
    "insurance_partner_desc": "It will be integrated as one included booking coverage option. No plans to choose.",
    "insurance_agency_summary": "Verified host-provided policy",
    "placeholder_owner_name": "Owner name",
    "features_selected": "{{count}} selected",
    "review_title": "Review and publish",
    "no_make_model": "Make/model not selected",
    "address": "Pickup address",
    "use_current_location": "Use my current location",
    "document_scan_failed": "We could not open the scanner. Check your connection and try again, or take a normal photo.",
    "publish_needs_verification": "To publish you will need to verify your identity. Go ahead and finish the vehicle: we save it and take you to verification at the end.",
    "address_placeholder": "e.g. Col. Escalón, San Salvador",
    "map_unavailable_title": "We couldn't load the map",
    "map_unavailable_body": "Keep going with the address above — we use it to place your car on the map.",
    "delivery_radius": "Delivery radius (km)",
    "delivery_radius_placeholder": "10",
    "step_documents": "Documents",
    "tarjeta_circulacion": "Vehicle registration",
    "documents_callout_title": "Vehicle document (not your driver license)",
    "documents_callout_body": "Upload the vehicle registration card: plate, owner, and VIN. Your personal driver license is verified in your profile, not in this step.",
    "tarjeta_wrong_license": "That's a driver license. We need the vehicle registration card (plate and owner).",
    "tarjeta_wrong_dui": "That's a national ID. We need the vehicle registration card.",
    "tarjeta_number": "Registration number",
    "tarjeta_number_placeholder": "e.g. 00000000",
    "tarjeta_expiry": "Expiry date",
    "tarjeta_owner": "Owner",
    "tarjeta_scan": "Scan registration",
    "tarjeta_scanning": "Scanning document...",
    "tarjeta_scan_failed": "Could not verify. Take or upload a clearer photo.",
    "tarjeta_front_photo": "Front photo",
    "tarjeta_back_photo": "Back photo",
    "tarjeta_expired_error": "Registration is expired",
    "tarjeta_required": "Vehicle registration is required",
    "tarjeta_back_required": "Capture the back of the vehicle registration",
    "document_live_capture_required": "Capture this document live inside Tago.",
    "tarjeta_mismatch_warning": "We will review these details without stopping publishing",
    "tarjeta_confidence_low": "Could not read all fields with enough confidence.",
    "tarjeta_confidence_ok": "Fields read with {{percent}}% confidence",
    "tarjeta_confidence_warning": "Only {{percent}}% confidence. Check each field before continuing.",
    "tarjeta_ai_required": "Registration must be verified",
    "tarjeta_back_ai_required": "The back of the registration must be verified",
    "tarjeta_ai_approved": "Front and back verified",
    "tarjeta_mismatch_blocked": "We will review these details before final listing approval.",
    "policy_document": "Insurance policy",
    "policy_photo": "Vehicle coverage",
    "policy_photo_hint": "Agencies can upload their own policy or use platform coverage.",
    "policy_upload_now": "Capture policy",
    "policy_own": "Own policy",
    "policy_qualitas": "Qualitas coverage",
    "policy_defer": "Qualitas coverage",
    "policy_deferred_notice": "The listing stays in review under Qualitas coverage until authorization.",
    "policy_agency_choice_hint": "Choose how this vehicle is covered: your own policy or platform coverage. Bookings unlock when coverage is ready.",
    "policy_qualitas_agency_notice": "We send the listing to review with platform coverage. No need to upload your own policy.",
    "policy_non_platform": "Covered by own policy",
    "policy_non_platform_notice": "This vehicle is not eligible for the available platform coverage based on its category or age. You can apply with a current, verifiable own policy.",
    "non_platform_pending_notice": "This category requires a current own policy; the listing stays pending until it is verified.",
    "non_platform_review_banner": "This category requires its own policy. The listing stays pending until it is verified.",
    "individual_qualitas_title": "Qualitas coverage",
    "individual_qualitas_body": "As a natural person you do not upload a policy. We send the listing to review and the insurer authorizes coverage. Bookings unlock when approved.",
    "individual_qualitas_pending_notice": "Listing ready for coverage review. No own policy needed.",
    "individual_qualitas_review_banner": "Natural person: the listing stays in review until Qualitas authorization. It is not published instantly.",
    "auto_title_suffix": "on Tago",
    "auto_description_suffix": "Ready to rent in El Salvador with Qualitas coverage.",
    "policy_scanning": "Verifying policy...",
    "policy_required": "Insurance policy is required",
    "policy_expired_error": "Policy is expired",
    "policy_ai_required": "Policy must be verified",
    "policy_not_approved": "This policy does not meet the publishing requirements.",
    "policy_scan_failed": "Could not verify the policy. Capture a clearer photo of the full document.",
    "policy_ai_approved": "Policy verified",
    "policy_ai_needs_review": "Policy needs review",
    "policy_number": "Policy number",
    "policy_expiry": "Policy expiry",
    "policy_unknown_insurer": "Insurer not read",
    "policy_unknown_number": "Number not read",
    "policy_unknown_expiry": "Expiry not read",
    "take_photo": "Take photo",
    "scan_document": "Scan document",
    "choose_gallery": "Choose from gallery",
    "choose_file": "Choose file",
    "skip_documents": "Skip for now",
    "skip_documents_hint": "We save the draft and you can upload documents later.",
    "documents_pending_banner": "We save the listing as a draft until you capture the vehicle registration.",
    "documents_partial_pending_banner": "We save the registration. The listing stays in review under Qualitas coverage; bookings unlock when authorized.",
    "document_review_pending_banner": "We received the documents. The listing stays in review; bookings unlock when the insurer authorizes coverage.",
    "document_review_required_title": "A document needs correction",
    "document_review_required_desc": "Upload a new capture from this screen so operations can review it again.",
    "document_review_reason_fallback": "We could not validate this document. Upload a clear photo of the full document.",
    "document_review_reupload_note": "The new submission replaces the previous attempt and keeps the vehicle in review until approved.",
    "document_label_tarjeta_front": "Registration front",
    "document_label_tarjeta_back": "Registration back",
    "document_label_insurance_policy": "Insurance policy",
    "document_label_generic": "Document",
    "draft_preserved_after_publish_error": "We saved the vehicle as a draft. Fix the issue and tap Publish again; you do not need to start over.",
    "camera_permission_denied": "Camera permission required",
    "camera_permission_settings_cta": "Open settings",
    "photo_progress": "Photo {{current}} of {{total}}",
    "camera_torch": "Flashlight",
    "camera_need_light": "This photo needs good light. Turn on the flashlight or take it during the day.",
    "ai_generate": "Generate with AI",
    "ai_generating": "Generating...",
    "ai_generate_description": "Create an appealing description with AI",
    "ai_generation_failed": "Generation failed. Write your own description.",
    "ai_regenerate": "Regenerate",
    "ai_suggested_price": "Suggested price",
    "ai_price_range": "Market range",
    "ai_price_budget": "Budget",
    "ai_price_competitive": "Competitive",
    "ai_price_premium": "Premium",
    "ai_price_no_data": "Not enough data to suggest a price",
    "ai_price_based_on": "Based on {{count}} similar vehicles",
    "ai_use_suggestion": "Use suggestion",
    "categories": {
      "sedan": "Sedan",
      "suv": "SUV",
      "pickup": "Pickup",
      "van": "Van",
      "microbus": "Minibus",
      "compact": "Compact",
      "luxury": "Luxury",
      "sports": "Sports",
      "motorcycle": "Motorcycle",
      "heavy_duty": "Heavy Duty",
      "recreational": "Fun"
    },
    "transmissions": {
      "automatic": "Automatic",
      "manual": "Manual",
      "cvt": "Automatic",
      "dct": "Automatic"
    },
    "fuel_types": {
      "gasoline": "Gasoline",
      "diesel": "Diesel",
      "electric": "Electric",
      "hybrid": "Hybrid",
      "plugin_hybrid": "Plug-in Hybrid"
    },
    "vehicle_features": {
      "diesel_included": "Diesel included",
      "driver_included": "Driver included",
      "diesel_included": "Diesel included",
      "driver_included": "Driver included",
      "ac": "Air conditioning",
      "bluetooth": "Bluetooth",
      "gps": "GPS",
      "usb": "USB",
      "backup_camera": "Backup camera",
      "cruise_control": "Cruise control",
      "sunroof": "Sunroof",
      "heated_seats": "Heated seats",
      "leather_seats": "Leather seats",
      "keyless_entry": "Keyless entry",
      "android_auto": "Android Auto",
      "apple_carplay": "Apple CarPlay",
      "child_seat": "Child seat",
      "roof_rack": "Roof rack",
      "tow_hitch": "Tow hitch",
      "spare_tire": "Spare tire",
      "dash_cam": "Dash cam",
      "first_aid_kit": "First aid kit"
    },
    "validation": {
      "make_required": "Select a make",
      "model_required": "Select a model",
      "year_too_old": "Year is too old",
      "year_too_new": "Year cannot be in the future",
      "category_required": "Select a category",
      "color_required": "Color is required",
      "color_max": "Maximum 30 characters",
      "transmission_required": "Select transmission",
      "fuel_type_required": "Select fuel type",
      "seats_min": "Minimum 1 seat",
      "seats_max": "Maximum 15 seats",
      "doors_min": "Minimum 2 doors",
      "doors_max": "Maximum 6 doors",
      "plate_required": "Plate number is required",
      "plate_max": "Maximum 15 characters",
      "vin_length": "VIN must be 17 characters",
      "vin_format": "Invalid VIN format",
      "title_min": "Minimum 10 characters",
      "no_contact": "Don't include phone numbers, emails or social handles: coordination goes through Tago chat.",
      "title_max": "Maximum 80 characters",
      "description_min": "Minimum 30 characters",
      "description_max": "Maximum 1000 characters",
      "features_min": "You can continue without selecting features",
      "features_max": "Maximum 20 features",
      "rules_max": "Maximum 500 characters",
      "photos_min": "Complete the 17 inspection shots",
      "photos_max": "Exactly 17 inspection shots are required",
      "photos_required_all": "Complete the 17 inspection shots before continuing",
      "photos_live_only": "Every photo must be captured live inside Tago",
      "photos_duplicate_slot": "Each inspection shot must be captured once",
      "address_required": "Address is required",
      "country_required": "Country is required",
      "daily_rate_min": "Minimum $15/day",
      "daily_rate_max": "Maximum $1,000/day",
      "security_deposit_max": "Maximum $500 deposit",
      "security_deposit_min": "The deposit cannot be negative",
      "min_rental_invalid": "Choose a valid minimum duration.",
      "plate_exists": "An active vehicle already uses that plate. Check the plate or edit the existing vehicle.",
      "insurance_agency_only": "For now, all listings must use a verified host-provided policy.",
      "location_must_be_sv": "Vehicle location must be inside El Salvador"
    }
  },
  "privacy": {
    "intro": "This Privacy Policy is prepared per the Personal Data Protection Law of El Salvador (Decree 144/2024). TAKE AND GO, S.A.S. DE C.V. (hereinafter, \"Tago\") describes here how it collects, uses, and discloses your data. Full version at tago.rent/es/legal/privacy-policy.",
    "data_collection_title": "Data collection",
    "data_collection_body": "We collect: (a) data you provide directly — name, email, password, phone, address, driver license, profile photos, date of birth, vehicle data (VIN, location, photos), payment data processed by PCI-DSS certified providers, identity verification data (DUI front and back, passport, NIT, driving history) and biometric data (facial recognition) only with your express consent; (b) automatic data — usage, location (with consent), device, trip, cookies; (c) third-party data — social sign-in, in-vehicle devices, background verification to the extent permitted by law.",
    "data_usage_title": "Data usage",
    "data_usage_body": "We use your data to: provide and operate the Services (account management, bookings, support, communications), research and development (aggregated or anonymized data), marketing with your express consent, security and protection (verify identity, detect fraud, assess risk), and comply with applicable Salvadoran legislation. We never sell your personal data.",
    "data_sharing_title": "Data sharing",
    "data_sharing_body": "We only disclose data: with your express consent; in public profiles (name, photo, vehicle city, reviews); between Hosts and Guests upon Booking confirmation (phone, license, delivery address); with service providers under confidentiality (hosting, payments, insurance, assistance, customer support) and only what is necessary for verification, coverage, or claims; with professional advisors; in business transfers; or upon legal requests.",
    "user_rights_title": "Your ARCO-POL rights",
    "user_rights_body": "Per Decree 144/2024 you have ARCO-POL rights:\n\n• Access — know what data we hold about you. In the app: Profile → Download my data.\n• Rectification — correct inaccurate data. In the app: Profile → Edit profile.\n• Cancellation / Erasure — request deletion when no longer necessary. In the app: Profile → Delete account.\n• Opposition — object to processing for specific purposes. Exercised by written request to privacy@tago.rent; there is no in-app control for this yet.\n• Portability — receive your data in a structured format. In the app: Profile → Download my data.\n• Right to be Forgotten — request deletion when data is inadequate or excessive. Exercised by written request to privacy@tago.rent.\n• Limitation — temporary suspension of processing. Exercised by written request to privacy@tago.rent; there is no in-app control for this yet.\n\nTo exercise them, email privacy@tago.rent or the Data Protection Officer at dpo@tago.rent. Your request must state your name, your identity document, a description of the data, the right you are exercising, and be signed (Art. 18); if something is missing we issue a single prevention notice and you have 10 business days to complete it.\n\nWe respond within a maximum of 20 business days (Art. 20), extendable once by up to 20 additional business days, with notice of the extension. If we deny your request in whole or in part, we notify you by reasoned resolution within the following 3 business days (Art. 22). Free of charge.\n\nTo close your account and delete your data, use Profile → Delete account or email cuentas@tago.rent. Where a law requires us to safekeep information — invoicing and DTE 10 years, commercial relationship records 10 years — those records are blocked, available only to authorities and for the defence of claims, rather than deleted (Art. 11).",
    "contact_title": "Contact",
    "contact_body": "General privacy — privacy@tago.rent\nData Protection Officer (DPO) — dpo@tago.rent\nAccount closure — cuentas@tago.rent\n\nSupervisory authority: State Cybersecurity Agency (ACE) — agenciadeciberseguridad.gob.sv"
  },
  "terms": {
    "effective_date": "Last updated: April 15, 2026",
    "intro": "These Terms and Conditions govern your use of Tago, a peer-to-peer vehicle rental platform operated in the Republic of El Salvador by TAKE AND GO, S.A.S. DE C.V., a Salvadoran company registered with the Commercial Registry of the CNR under entry 152, book 4942, since March 10, 2026. By creating an account or confirming a Booking, you accept these Terms. Full version at tago.rent/es/legal/terms-of-service.",
    "eligibility_title": "Eligibility and verification",
    "eligibility_body": "To use Tago you must:\n\n• Be a natural person over 18 with full legal capacity (Art. 1316 Civil Code).\n• Hold a valid driver license valid for the vehicle category.\n• Complete identity verification: DUI, passport, or other official document; facial biometric verification with your express consent; phone and email verification.\n• Accept these Terms and the Privacy Policy.\n\nEach natural person maintains a single account. Tago may suspend or cancel accounts with false information, breaches, or signs of fraud.",
    "platform_role_title": "Platform role",
    "platform_role_body": "Tago is a technology intermediation platform. Tago is not a party to the rental contract between Host and Guest, which is governed by Arts. 1703 et seq. of the Civil Code. Tago facilitates payment, verification, and dispute mediation.\n\nTago reserves the right to modify these Terms. Material changes will be notified at least 15 days before they take effect.",
    "rental_rules_title": "Rental rules",
    "rental_rules_body": "During the Trip, the Guest undertakes to:\n\n• Drive the vehicle personally and not transfer it to unauthorized third parties.\n• Comply with the Land Transport, Traffic, and Road Safety Law (Decree 477/1995).\n• Not drive under the influence of alcohol or other substances.\n• Immediately report accidents, damages, or incidents.\n• Not smoke inside the vehicle nor transport illegal substances or commercial cargo.\n• Not leave Salvadoran territory without written authorization from the Host and Tago.\n• Return the vehicle with the same fuel level, or pay the equivalent.\n\nForbidden: subleasing the vehicle, modifying it, towing other vehicles, or paying the Host outside the Platform.",
    "payment_title": "Payments and taxes",
    "payment_body": "Payments in U.S. dollars (USD), legal tender in El Salvador. During the pilot, prices shown before checkout display the base fare; the Guest's final price is presented at the payment step. Tago does not store card data — PCI-DSS certified providers process them. Tago does not accept cash payments between Host and Guest for Booking-related concepts.\n\nThe Trip Price includes base fare, Tago service commission, and optional add-ons. Some vehicles may carry a refundable security deposit set by the Host; when it applies it is shown before payment, charged together with the Booking, held by Tago, and returned to the Guest in full after the Trip if there is no damage. Host earnings are transferred to the registered account within 48 hours of Trip completion. The Host is responsible for declaring and paying the taxes corresponding to their rental income (ISR and VAT when applicable).",
    "cancellation_title": "Cancellations",
    "cancellation_body": "Right of withdrawal (derecho de retracto, Art. 13-A LPC): within 8 days of booking and before the Trip starts, you may cancel without justification or penalty and all sums paid — including the commission — are reversed within 15 days. This rule prevails over the tiers below.\n\nOutside that case, Tago's service commission is not refunded in Guest cancellations. It is only refunded when the Host or Tago cancels, or when the Trip is not rendered.\n\nBase rental price summary:\n\n• Cancellation more than 48 hours before: 100% to Guest.\n• Between 24 and 48 hours before: 50% to Guest, 50% to Host.\n• Less than 24 hours: 0% to Guest, 100% to Host.\n• No-show: 0% to Guest, 100% to Host; insurance and add-ons not refunded.\n• Host cancellation: 100% to Guest + Host fees ($25 / $50 / $150 by notice).\n• Tago cancellation: 100% to Guest.\n\nFull detail on the Cancellation Policy screen.",
    "insurance_title": "Insurance",
    "insurance_body": "Every listed vehicle must have its own active policy or certificate verified, or approved platform coverage, before it goes live. Included coverage is a single option with no plans to choose: the per-day premium is integrated into the booking total and charged at checkout.\n\nThe policy must issue before the trip is confirmed. If it cannot be issued, Tago will cancel the booking and process the corresponding refund.\n\nThe security deposit is optional and set by each Host; when it applies it is refundable and returned in full after the Trip if there is no damage.",
    "liability_title": "Limitation of liability",
    "liability_body": "Tago does not assume direct liability for: the mechanical condition of listed vehicles, the accuracy of Host information, User behavior during the Trip, accidents or fines during the Trip, loss of Guest personal belongings, or damages to third parties caused by the Guest.\n\nTago's total liability to a User will not exceed the total service commissions paid by that User in the 12 months prior to the event. These limitations do not apply in case of willful misconduct or gross negligence by Tago, nor where the Consumer Protection Law prohibits them.",
    "disputes_title": "Dispute resolution",
    "disputes_body": "Step 1 — Direct communication between the parties via Tago messaging within 48 hours of the event.\n\nStep 2 — Tago mediation: escalate to hola@tago.rent within 5 calendar days of the Trip, attaching documentation.\n\nStep 3 — Non-binding Tago resolution within 10 business days.\n\nIf unsatisfactory, parties may resort to the Mediation Center of the Ministry of Justice, the Arbitration and Mediation Center of CCIES, or the civil and commercial courts of San Salvador. Consumers may file with the Consumer Defense Office (defensoria.gob.sv · Tel. 910).",
    "termination_title": "Termination and account deletion",
    "termination_body": "You may delete your account at any time from Profile → Delete account (at the bottom of the Profile menu, next to Log out), or by writing to cuentas@tago.rent. If you want a copy of your information first, use Profile → Download my data.\n\nWhen you request it we open a 30-day grace period — our own product choice, not the legal deadline for responding to data requests — during which you may cancel the deletion. After those 30 days, personal data is irreversibly anonymized.\n\nRecords we are legally required to safekeep (invoicing and DTE 10 years, commercial relationship records 10 years) are not deleted: they are blocked, available only to authorities and courts and for the defence of claims (Art. 11, Decree 144/2024).\n\nCancellation does not relieve the User from pending obligations generated before cancellation.",
    "governing_law_title": "Governing law and jurisdiction",
    "governing_law_body": "These Terms are governed by the laws of the Republic of El Salvador (Civil Code, Commercial Code, Consumer Protection Law Decree 776/2005, Personal Data Protection Law Decree 144/2024, Cybersecurity Law, Land Transport Law Decree 477/1995, among others). The parties expressly submit to the jurisdiction of the civil and commercial courts of San Salvador, waiving any other venue. The Spanish version of these Terms is the official and binding version.",
    "contact_title": "Contacts",
    "contact_body": "Customer support — hola@tago.rent\nPrivacy and data — privacy@tago.rent\nData Protection Officer (DPO) — dpo@tago.rent\nLegal matters — legal@tago.rent\nAccount closure — cuentas@tago.rent"
  },
  "cancellation_policy": {
    "intro": "This Policy governs refunds and fund attribution when a Booking is not completed. Full version at tago.rent/es/legal/cancellation-policy.\n\nGuiding principle: Tago's service commission is not refunded in Guest cancellations or force majeure. It is only refunded when the Host or Tago's Trust and Safety team cancels. The base price not refunded to the Guest is credited to the Host.",
    "full_refund_title": "Guest cancellation — more than 48 hours before",
    "full_refund_body": "• Base rental price: 100% to Guest.\n• Insurance and unused add-ons: 100%.\n• Tago service commission: non-refundable.\n\nThe Host receives no compensation because there is enough time to reassign availability.",
    "partial_refund_title": "Guest cancellation — between 24 and 48 hours before",
    "partial_refund_body": "• Base rental price: 50% to Guest.\n• Insurance and unused add-ons: 100%.\n• Tago service commission: non-refundable.\n\nThe Host receives the remaining 50% of the base price as compensation for blocked availability.",
    "no_refund_title": "Guest cancellation — less than 24 hours",
    "no_refund_body": "• Base rental price: 0% to Guest.\n• Insurance and unused add-ons: 100%.\n• Tago service commission: non-refundable.\n\nThe Host receives 100% of the base price as compensation for blocked availability.",
    "no_show_title": "Guest no-show",
    "no_show_body": "A no-show occurs if the Guest does not cancel and does not show up within 30 minutes after the scheduled start, or shows up without a valid license or sends an unauthorized third party.\n\n• Base price: 0% to Guest, 100% to Host.\n• Insurance and add-ons: 0% (already activated).\n• Tago service commission: non-refundable.\n\nThe Host must report the no-show within 72 hours of scheduled start.",
    "host_cancellation_title": "Host cancellation",
    "host_cancellation_body": "If the Host cancels a confirmed Booking, the Guest receives a full refund of all amounts: base price, Tago service commission, insurance, and add-on services.\n\nThe Host is subject to cancellation fees:\n• More than 24 hours notice: $25.\n• Less than 24 hours: $50.\n• Host no-show (>30 min after start): $150.\n\nRepeated cancellations may result in reduced placement or account suspension.",
    "tago_cancellation_title": "Tago cancellation",
    "tago_cancellation_body": "Trust and Safety may cancel a Booking in exceptional cases (breach of Terms, safety risk, open investigation).\n\n• Guest: 100% of all amounts, including service commission.\n• Host: if Tago cancels with more than 24 hours notice, no earnings. With less than 24 hours, proportional compensation based on Trip duration.",
    "force_majeure_title": "Force majeure",
    "force_majeure_body": "For cancellations motivated by force majeure (natural disasters, national emergencies, pandemic declared by competent authority, or other unforeseeable events), Tago evaluates case by case.\n\nDefault: Guest receives 100% of base price, insurance, and add-ons; Tago service commission is not refunded; Host receives no compensation but no penalty either.",
    "disputes_title": "Cancellation disputes",
    "disputes_body": "If you believe a cancellation was processed incorrectly, open a dispute from your Trip history within 48 hours. The counterparty has 72 hours to respond with evidence.\n\nIf no agreement is reached, Tago reviews the evidence and issues a non-binding resolution within 10 business days. Unresolved disputes are governed by Salvadoran legislation and fall under the jurisdiction of the courts of San Salvador. You may also file with the Consumer Defense Office (defensoria.gob.sv · Tel. 910)."
  },
  "data_export": {
    "title": "Export Data",
    "description": "You can request a complete copy of your personal data stored in Tago. This includes your profile, trip history, messages, reviews, and any other data associated with your account.",
    "arco_title": "What are ARCO rights?",
    "arco_body": "ARCO-POL rights (Access, Rectification, Cancellation, Opposition, Portability, Right to be Forgotten, and Limitation) let you control how your personal data is handled. By requesting an export you are exercising your rights of Access and Portability.",
    "request_button": "Request data export",
    "processing_note": "The export is generated instantly and saved to your device. If you request your data in writing at privacy@tago.rent, the legal response deadline is 20 business days, extendable once by up to 20 additional business days with notice.",
    "saved_to_cache": "Saved to app cache. Email privacy@tago.rent if you need a different delivery.",
    "success": "Data export ready.",
    "error": "Could not generate export.",
    "requesting": "Generating export…",
    "regenerate": "Re-download data",
    "completed_note": "Your data was exported. The file is in your downloads / share sheet.",
    "email_fallback_intro": "Need a different format or assistance? Email us:"
  },
  "payment_methods": {
    "title": "Payment methods",
    "trust_title": "Protected by Wompi",
    "trust_body": "Wompi tokenizes your cards. Tago only shows brand, last 4 digits, and expiry so you can recognize them.",
    "empty_title": "Add your first card",
    "empty_desc": "Save cards to pay faster without typing every detail each time.",
    "add": "Add card",
    "add_first": "Add card",
    "add_desc": "The card is tokenized with Wompi. For future payments, we may ask for CVV for security.",
    "nickname": "Card name",
    "nickname_placeholder": "Personal, work, debit...",
    "make_default": "Use as default",
    "save_card": "Save card",
    "secure_footnote": "Wompi protects the card. Tago does not store the full card number or CVV.",
    "load_error": "We could not load your cards. Try again.",
    "default_badge": "Primary",
    "set_default": "Make primary",
    "expiry": "expires {{expiry}}",
    "card": "Card",
    "delete_title": "Remove card",
    "delete_desc": "This card will be removed from your saved payment methods. You can add it again anytime."
  },
  "org": {
    "title": "Organization",
    "settings_title": "Organization settings",
    "no_organization": "No organization yet",
    "create": "Create organization",
    "create_desc": "Set up your company with NIT and legal representative to manage vehicles, team members, and earnings in one place.",
    "create_and_publish": "Create agency and list",
    "create_failed": "We couldn't create the organization. Check the details and try again.",
    "created_title": "Organization created",
    "created_desc": "You can now invite members and add vehicles.",
    "join": "Join an existing one",
    "join_coming_soon": "This feature will be available soon.",
    "skip": "Continue without organization",
    "skip_hint": "You can set this up later from the hosting dashboard.",
    "detected_title": "This vehicle belongs to a company",
    "detected_desc": "To manage company vehicles, you can create an organization and manage your team.",
    "name": "Organization name",
    "name_placeholder": "e.g. Transportes Mejía",
    "legal_name": "Legal entity name",
    "legal_name_placeholder": "COMPANY XYZ, S.A. DE C.V.",
    "legal_info": "Legal information",
    "tax_id": "Tax ID (NIT)",
    "tax_id_placeholder": "0614-050707-104-8",
    "tax_id_helper": "Registered company or agency NIT. We use it for legal validation and invoicing.",
    "tax_id_helper_empty": "Type the 14 digits; we add hyphens automatically.",
    "tax_id_helper_progress": "{{count}} digits left to complete the NIT.",
    "tax_id_helper_valid": "NIT format and verification digit are valid.",
    "tax_id_accessibility_hint": "Enter the 14-digit NIT. Tago will add the hyphens automatically.",
    "tax_id_exists": "An active organization already exists with that NIT.",
    "limit_reached": "You've reached the maximum number of organizations.",
    "legal_representative": "Legal representative",
    "legal_representative_desc": "We will use your verified profile as the responsible representative for this company.",
    "email": "Email",
    "email_placeholder": "contact@company.com",
    "phone": "Phone",
    "phone_placeholder": "+503 0000-0000",
    "website": "Website",
    "insurance_model": "Insurance model",
    "insurance_platform": "Platform insurance",
    "insurance_fleet": "Fleet's own insurance",
    "insurance_hybrid": "Hybrid",
    "insurance_none": "No insurance",
    "members": "Team members",
    "no_members": "No members yet",
    "no_members_desc": "Invite the people who will drive the company's vehicles by email or phone.",
    "invite_member": "Invite member",
    "invite_sent": "Invitation sent. If this person does not have Tago yet, they'll be added after creating an account.",
    "invite_already_exists": "This person has already been invited to the organization.",
    "pending_invites": "Pending invitations",
    "invite_pending_external": "Invited member",
    "invite_pending_desc": "They'll be added automatically when they create a Tago account with this contact.",
    "invite_by_phone": "Invite by phone",
    "invite_by_email": "Invite by email",
    "invite_method_email": "Email",
    "invite_method_phone": "Phone",
    "role_label": "Role",
    "role_manager": "Manager",
    "role_driver": "Driver",
    "verification": "Company verification",
    "verification_pending": "Verification pending",
    "verification_desc": "Upload the legal representative's documents and complete fiscal information to verify the company.",
    "verified": "Company verified",
    "claim_vehicles": "Claim vehicles",
    "claim_desc": "We found {{count}} vehicles registered to your company",
    "dashboard": "Organization dashboard",
    "earnings": "Earnings",
    "vehicles": "Vehicles",
    "settings": "Settings",
    "remove_member": "Remove member",
    "remove_confirm": "Are you sure you want to remove {{name}}?",
    "member_removed": "Member removed",
    "prefilled_from_tarjeta": "Pre-filled from vehicle registration card",
    "company_prompt": "Does this vehicle belong to a company?",
    "join_search_placeholder": "Search by company name...",
    "join_confirm_title": "Request to join",
    "join_confirm_desc": "Request to join {{name}}? A manager will need to approve your request.",
    "join_request_sent": "Join request sent",
    "join_no_results": "No organizations found",
    "fleet_mode": "Fleet mode",
    "active_org": "Active organization",
    "vehicle_claimed": "Vehicle added to the fleet",
    "claim_vehicle_action": "Add",
    "not_member_title": "This organization isn't yours",
    "not_member_body": "You're not on this organization's team, so you can't see or change its details. If you were just invited, accept the invitation from your email.",
    "not_member_action": "See my organizations",
    "not_manager_title": "Only an admin can change this",
    "not_manager_body": "You're on the team, but changing the organization's details or inviting people is done by an admin. Ask whoever manages the fleet.",
    "not_manager_action": "Back to the team"
  },
  "aml": {
    "title": "Compliance",
    "intro_title": "Details for {{partner}}",
    "intro_body": "Your identity is already verified, so we won’t ask for it again. What’s left is the declaration the law requires, and we keep it on file so {{partner}} can issue your coverage as soon as it goes live. It’s taps, not forms.",
    "section_identity": "What we already know about you",
    "section_identity_helper": "Taken from your verified document and your profile. Just confirm it’s right; tap Edit if something changed.",
    "source_identity_document": "From your verified document",
    "source_profile": "From your Tago profile",
    "source_confirmed": "You confirmed this",
    "identity_edit_a11y": "Edit the details we already have",
    "identity_edit_close_a11y": "Finish editing your details",
    "section_economic": "Your activity",
    "section_economic_helper": "Never shown on your profile and never seen by hosts: {{partner}} uses it for compliance only. Everything here is one tap.",
    "section_declarations": "Declarations",
    "section_declarations_helper": "The law requires these questions, and they protect both sides of the trip. A “Yes” does not close the door — it routes you to a person.",
    "section_disclaimer": "{{partner}} authorization",
    "section_cross_border": "International transfer",
    "full_name": "Full name",
    "phone": "Phone",
    "date_of_birth": "Date of birth",
    "gender": "Gender",
    "gender_option": {
      "female": "Female",
      "male": "Male",
      "other": "Other",
      "prefer_not_to_say": "Prefer not to say"
    },
    "nationality": "Nationality",
    "nationality_placeholder": "Choose your nationality",
    "origin_country": "Country of origin",
    "origin_country_placeholder": "Choose country of origin",
    "residence_country": "Country of residence",
    "residence_country_placeholder": "Choose where you live",
    "income_range": "Monthly income range",
    "income_option": {
      "1_800": "$1 – $800",
      "801_2000": "$801 – $2,000",
      "2001_4500": "$2,001 – $4,500",
      "4501_6500": "$4,501 – $6,500",
      "6501_10000": "$6,501 – $10,000",
      "10001_plus": "More than $10,001"
    },
    "economic_activity": "Economic activity",
    "economic_activity_placeholder": "Choose your activity",
    "activity_option": {
      "employee_private": "Private-sector employee",
      "employee_public": "Public-sector employee",
      "merchant": "Merchant or own business",
      "independent_professional": "Independent professional",
      "health": "Healthcare",
      "education": "Education",
      "transport": "Transport and logistics",
      "construction": "Construction and trades",
      "agriculture": "Farming, livestock and fishing",
      "tourism_hospitality": "Tourism, hotels and restaurants",
      "technology": "Technology and telecom",
      "finance": "Financial services and insurance",
      "security": "Security and surveillance",
      "student": "Student",
      "retired": "Retired or pensioner",
      "homemaker": "Homemaker",
      "unemployed": "No economic activity right now",
      "other": "Other activity"
    },
    "fund_origin": "Source of funds",
    "fund_option": {
      "salaried": "Salaried employee",
      "independent_merchant": "Independent merchant",
      "independent_professional": "Independent professional"
    },
    "is_pep": "Do you hold or have you held a Politically Exposed Person (PEP) role?",
    "is_pep_helper": "Includes high-level public office, national or international.",
    "is_party_member": "Are you a member of a political party?",
    "has_pep_family": "Do you have a family member who holds a Politically Exposed Person role?",
    "has_pep_associate": "Do you have an associate who holds a Politically Exposed Person role?",
    "tax_haven": "Have you had employment or commercial ties with countries identified as tax havens?",
    "tax_haven_helper": "Answer to the best of your knowledge.",
    "illicit_judicial": "Have you been in judicial proceedings or linked to illicit or terrorist activities?",
    "illicit_judicial_helper": "Required by law. Your answer is confidential.",
    "pep_review_title": "A person reviews this",
    "pep_review_body": "When public office is involved, {{partner}} does not issue the policy automatically. Send your declaration anyway: our team handles it with the insurer and gets back to you. Nothing you already answered is lost.",
    "disclaimer_helper": "Read the full text and check the box to accept. You can uncheck it.",
    "disclaimer_scroll_hint": "Keep scrolling",
    "disclaimer_accept_label": "I have read and accept the declaration and authorization to {{partner}}",
    "disclaimer_step_title": "{{partner}} declaration",
    "disclaimer_step_subtitle": "Authorize {{partner}} to verify what you submitted.",
    "disclaimer_step_submit": "Accept and finish",
    "disclaimer_step_saved": "Declaration accepted.",
    "disclaimer_step_error": "We couldn't save your declaration. Try again.",
    "disclaimer_step_already_accepted": "You already accepted the {{partner}} declaration. We stored it with the date and the exact version of the text you read.",
    "disclaimer_step_footnote": "Your acceptance is recorded with the date and the version of the text. {{partner}} uses this authorization only to validate your information.",
    "cross_border_title": "Your data leaves El Salvador",
    "cross_border_body": "Once coverage goes live, {{partner}} will need this declaration and your identity details, and processes them on its systems in Mexico. Your authorization is stored from now; until then nothing leaves El Salvador. You can withdraw it whenever you want by writing to privacy@tago.rent.",
    "cross_border_label": "I authorize sending my data to {{partner}} in Mexico to issue my coverage",
    "cross_border_declined_title": "No coverage without this authorization",
    "cross_border_declined_body": "It is your call and you can leave it unchecked. It just means {{partner}} will not be able to issue your policy once coverage goes live, and the declaration is required to book. Close this screen and come back when you are ready, or write to us at privacy@tago.rent.",
    "submit": "Submit and continue",
    "submit_manual_review": "Send for review",
    "success_title": "Details submitted",
    "success_body": "They’re under review with our coverage partner. We’ll let you know if anything else is needed.",
    "status_pending_title": "Compliance under review",
    "status_pending_body": "Your declaration is on file with the date and the exact version of the text you read. {{partner}} reviews it and validates the information against lists such as OFAC. Your identity and selfie are already stored.",
    "status_pending_note": "You don’t need to resubmit.",
    "status_approved_title": "Compliance approved",
    "status_approved_body": "Your declaration with {{partner}} is complete. You can book and list as usual.",
    "needs_update_body": "Please update your compliance declaration. Review the details and submit again.",
    "gate_required_toast": "Complete the compliance form to continue.",
    "error_incomplete": "Check the highlighted fields to continue.",
    "error_submit": "We couldn’t save your declaration. Try again.",
    "error_required": "This answer is required",
    "error_full_name": "Enter your full name",
    "error_phone": "Enter a valid phone number",
    "error_date_of_birth": "Enter your date of birth",
    "error_gender": "Choose an option",
    "error_nationality": "Choose your nationality",
    "error_origin_country": "Enter your country of origin",
    "error_residence": "Choose your country of residence",
    "error_income": "Choose an income range",
    "error_economic_activity": "Choose your economic activity",
    "error_fund_origin": "Choose the source of funds",
    "error_disclaimer": "You must accept the declaration",
    "error_disclaimer_scroll": "Scroll through the full text before accepting",
    "error_cross_border": "Your authorization to send the data to Mexico is missing",
    "step_title": "{{partner}} compliance",
    "step_subtitle": "AML form and coverage authorization",
    "step_locked": "Complete identity and selfie first",
    "partner_generic": "the insurer"
  },
  "updates": {
    "available": "An update is available",
    "restart": "Restart now",
    "later": "Later",
    "ota_ready_title": "Update ready",
    "ota_ready_body": "A Tago update has been downloaded. Restart when ready to apply it.",
    "mandatory_title": "Tago",
    "checking_body": "Preparing the app.",
    "downloading_body": "Downloading the latest improvement. The app will restart automatically.",
    "restarting_body": "Applying the update. This takes a few seconds.",
    "store_required_title": "Update required",
    "store_required_body": "This version is no longer supported. Update Tago to keep using bookings, payments, and verifications securely.",
    "store_available_title": "A new version of Tago is available",
    "store_available_body": "It downloads in the background and you can keep using the app. We'll tell you when it's ready to restart.",
    "store_prompt_body": "A new version of Tago is available. Update to receive security and stability fixes.",
    "native_capability_required_body": "This version does not include the native biometric verification module. Update Tago and try again.",
    "blocked_error_title": "Could not open Tago",
    "blocked_error_body": "We could not complete an internal check. Check your connection and try again.",
    "open_store": "Update Tago",
    "open_store_failed": "We couldn't open the store from here. Open the App Store or Play Store, search for \"Tago\", and install the latest version.",
    "retry": "Try again",
    "please_wait": "Please wait",
    "step_checking": "Checking",
    "step_policy": "Validating",
    "step_ready": "Opening",
    "step_downloading": "Downloading",
    "step_restarting": "Applying",
    "step_store": "Store",
    "step_retry": "Retry",
    "build_requirement": "Current build: {{current}} · Required: {{required}}",
    "ready_title": "A new version is ready",
    "ready_action": "Update",
    "ready_a11y": "A new version of Tago is ready. Tap Update to restart and apply it."
  },
  "coverage": {
    "already_issued": "A policy already exists for this vehicle on these dates. You were not charged again.",
    "not_available_yet": "Coverage isn't available for this vehicle yet. We're already on it.",
    "person_not_eligible": "We can't issue coverage for this person through this channel. Write to us and we'll help.",
    "temporarily_unavailable": "We couldn't issue coverage right now. Try again in a few minutes.",
    "vehicle_not_eligible": "This vehicle doesn't qualify for coverage. Contact us and we'll take a look."
  },
  "inspection": {
    "signatures_title": "Signatures",
    "signature_area": "{{who}}'s signature area",
    "signature_hint": "Sign here, {{who}}",
    "signature_clear": "Clear and sign again",
    "signature_guest": "guest",
    "signature_host": "host",
    "signatures_help": "Both people sign on this phone, next to the car.",
    "mark_damage": "Mark damage",
    "damage_marked": "Damage marked",
    "damage_hint": "Press and hold a photo to mark damage.",
    "not_available_title": "This booking is no longer available",
    "not_available_body": "It may have been cancelled, expired, or it isn't yours. Check your active trips.",
    "not_available_action": "Back to trips",
    "session_needed_title": "You need to sign in",
    "session_needed_body": "Sign back into your account to complete the handover.",
    "stage": {
      "cancelled_title": "This booking was cancelled",
      "cancelled_body": "There is no handover or return to record. If this looks wrong, get in touch.",
      "completed_title": "This trip already ended",
      "completed_body": "The return is already recorded. You can review the trip details.",
      "already_handed_over_title": "The car was already handed over",
      "already_handed_over_body": "The handover is recorded. What comes next is the return.",
      "not_paid_title": "Payment is still pending",
      "not_paid_body": "The handover unlocks as soon as the booking payment is confirmed.",
      "checkin_first_title": "The handover comes first",
      "checkin_first_body": "The return compares against the handover photos, so that one goes first.",
      "go_to_checkout": "Go to the return",
      "go_to_trip": "View trip"
    },
    "invalid": {
      "condition": "Choose the vehicle condition.",
      "photo_uri": "One of the photos did not save. Take it again.",
      "photo_area": "There is a photo of a kind we do not recognise. Take it again.",
      "photo_size": "One of the photos came out damaged. Take it again.",
      "photo_captured_at": "One of the photos lost its timestamp. Take it again.",
      "photo_source": "Photos must be taken with the Tago camera.",
      "photos_min": "Some vehicle photos are missing.",
      "photos_duplicated": "There are two photos of the same angle. Remove one.",
      "fuel_range": "Fuel goes from 0 to 100%.",
      "odometer_range": "Check the odometer reading.",
      "odometer_whole": "The odometer takes whole numbers.",
      "notes_long": "Notes cannot exceed 500 characters."
    },
    "evidence_incomplete": "The handover evidence is incomplete: the vehicle photos and both signatures are required.",
    "pickup_missing_body": "The vehicle handover has to be recorded before the trip can be marked as under way."
  },
  "steps": {
    "phone": {
      "label": "Confirm your phone",
      "eta": "30 sec"
    },
    "email": {
      "label": "Confirm your email",
      "eta": "1 min"
    },
    "identity_document": {
      "label": "A photo of your ID",
      "eta": "2 min"
    },
    "selfie": {
      "label": "A selfie",
      "eta": "30 sec"
    },
    "driver_license": {
      "label": "A photo of your licence",
      "eta": "1 min"
    },
    "aml_declaration": {
      "label": "A few insurance questions",
      "eta": "2 min"
    },
    "unknown_one": "One more step this app version does not recognise",
    "unknown_other": "{{count}} more steps this app version does not recognise"
  },
  "review_gate": {
    "kicker": "Trip completed",
    "title_guest": "How was your trip?",
    "title_host": "How was the trip with {{name}}?",
    "title_fallback": "How was the trip?",
    "context_guest": "{{vehicle}} · with {{name}}",
    "context_host": "{{name}} · traveled in {{vehicle}}",
    "context_fallback": "{{vehicle}}",
    "stars_label": "Your experience",
    "add_comment": "Add a comment",
    "comment_label": "Comment (optional)",
    "comment_placeholder": "Anything else you’d like to share?",
    "defer": "Not now",
    "submit": "Send",
    "rating_1": "Very bad",
    "rating_2": "Bad",
    "rating_3": "Average",
    "rating_4": "Good",
    "rating_5": "Excellent",
    "error_title": "The review could not be sent",
    "error_later": "We will try again next time you open the app."
  },
  "inspection_evidence": {
    "title": "Handover evidence",
    "checkin": "Handover",
    "checkout": "Return",
    "photos": "{{count}} photos",
    "damages": "{{count}} marked as damage",
    "no_damages": "No damage marked",
    "signed_both": "Signed by both parties",
    "signed_one": "One signature missing",
    "signed_none": "Not signed",
    "signature_host": "Host",
    "signature_guest": "Guest",
    "pending": "Not done yet",
    "signature_unavailable": "Signature on file (preview unavailable)"
  },
  "handover_presence": {
    "kicker": "Presence confirmation",
    "host_hint": "The guest enters the code on their phone: it proves you were both here at the same place and time.",
    "mint_cta": "Show presence code",
    "mint_again": "Generate another code",
    "mint_failed": "We couldn't generate the code. Try again.",
    "expires": "Expires in {{minutes}}:{{seconds}}",
    "code_a11y": "Presence code: {{code}}",
    "guest_label": "Code shown by the host",
    "guest_placeholder": "6 characters",
    "guest_cta": "Verify presence",
    "verify_failed": "The code doesn't match, was already used, or expired. Ask for another.",
    "verified": "Presence verified: both parties were here.",
    "verified_a11y": "Presence verified",
    "scan_cta": "Scan QR code",
    "scan_title": "Point at the host's code",
    "scan_body": "The QR only lives a few minutes. If it doesn't scan, type the 6 characters.",
    "scan_permission_cta": "Enable camera"
  },
  "services": {
    "coming_soon_title": "Services: coming soon",
    "coming_soon_body": "We are enabling towing, equipment and construction. Until then, the rest of Tago keeps working as usual.",
    "hero_eyebrow": "Tago Services",
    "hero_title": "Solutions so the work never has to stop.",
    "hero_body": "Request towing, equipment, construction, or freight from one place. Tago coordinates a proposal before any charge.",
    "hero_cta": "Request a service",
    "secondary_cta": "I need something else",
    "active_request_title": "Your active request",
    "open_request_accessibility": "Open {{category}} request",
    "category_title": "What do you need to solve?",
    "category_subtitle": "Start with a category; we only ask for the essentials next.",
    "how_it_works_title": "Simple, even if you have never requested this",
    "how_it_works": {
      "tell_us": {
        "title": "Tell us the essentials",
        "body": "Service, location, and when you need it. Nothing more to get started."
      },
      "we_coordinate": {
        "title": "Tago coordinates",
        "body": "We validate scope and present clear availability and pricing."
      },
      "you_confirm": {
        "title": "You confirm",
        "body": "There is no charge until you review and accept the proposal."
      }
    },
    "categories": {
      "tow": {
        "title": "Towing and roadside help",
        "description": "Towing, flatbed service, or roadside help.",
        "action": "Request towing and roadside help",
        "badge": "Request now"
      },
      "heavy_equipment": {
        "title": "Heavy equipment",
        "description": "Excavation, loading, and lifting.",
        "action": "Request heavy equipment",
        "badge": "Guided quote"
      },
      "construction": {
        "title": "Construction",
        "description": "Site work, terrain, and trades.",
        "action": "Request construction",
        "badge": "Guided quote"
      },
      "materials": {
        "title": "Freight and materials",
        "description": "Cargo, aggregates, and supplies.",
        "action": "Request freight and materials",
        "badge": "Guided quote"
      }
    },
    "needs": {
      "tow_vehicle": "Vehicle tow",
      "roadside_assistance": "Roadside help",
      "flatbed_tow": "Flatbed tow",
      "excavation": "Excavation",
      "earthmoving": "Earthmoving",
      "lifting": "Crane and lifting",
      "compaction": "Compaction",
      "concrete": "Concrete",
      "demolition": "Demolition",
      "site_labor": "Site labor",
      "site_preparation": "Site preparation",
      "material_delivery": "Materials delivery",
      "dump_truck": "Dump truck",
      "load_transport": "Cargo transport",
      "other": "Other"
    },
    "status": {
      "submitted": "Request received",
      "matching": "Finding availability",
      "quoted": "Proposal ready",
      "confirmed": "Confirmed",
      "in_progress": "On the way",
      "completed": "Completed",
      "cancelled": "Cancelled"
    },
    "status_detail": {
      "submitted": "We received your request. Tago will review the details before coordinating a proposal.",
      "matching": "We are validating providers and availability for this scope.",
      "quoted": "Your proposal is ready to review before confirming.",
      "confirmed": "The service was confirmed with the agreed details.",
      "in_progress": "The provider confirmed they are on their way or working on your request.",
      "completed": "This service was marked completed.",
      "cancelled": "This request was cancelled and will not create a charge."
    },
    "timeline": {
      "submitted": "We saved the details to coordinate it.",
      "matching": "We are looking for the best availability for your need.",
      "quoted": "You can review the proposed scope and price now.",
      "confirmed": "It was confirmed with the accepted proposal.",
      "in_progress": "The service is moving forward.",
      "completed": "The service is done.",
      "cancelled": "The request closed with no charge."
    },
    "requests_load_error_title": "We could not load your requests",
    "requests_load_error_body": "Your categories are still available. Try again to see tracking.",
    "form": {
      "title": "Request a service",
      "subtitle": "Tell us the minimum. Tago confirms scope and price before charging.",
      "service_label": "Service",
      "need_label": "What do you need?",
      "location_label": "Where do you need it?",
      "location_hint": "Service location",
      "location_placeholder": "Search for an address or place",
      "destination_label": "Where should we take it?",
      "destination_hint": "Tow destination",
      "destination_placeholder": "Search for the shop or final destination",
      "when_label": "When do you need it?",
      "timing_now": "I need it now",
      "timing_scheduled": "I want to schedule it",
      "date_label": "Preferred date",
      "window_morning": "Morning",
      "window_afternoon": "Afternoon",
      "window_flexible": "Flexible time",
      "now_note": "We send this request to coordination now. Arrival and price are confirmed before you accept.",
      "details_label": "Tell us a little more",
      "details_placeholder": "For example: the vehicle will not start, I need to excavate a 200 m² site, or move 10 cement bags.",
      "contact_note": "We use your account contact details only to coordinate this request. There is no charge yet.",
      "submit": "Send request",
      "location_picker_title": "Choose the service location",
      "destination_picker_title": "Choose the destination",
      "location_search_placeholder": "Search for an address, neighborhood, or place",
      "location_searching": "Searching places…",
      "location_empty": "We could not find that place. Try a more specific address.",
      "location_search_error": "We could not search places now. Check your connection and try again.",
      "error_incomplete": "Review the service, required locations, and details before sending it.",
      "error_national": "For now, Services only operates within El Salvador.",
      "error_location": "We could not confirm that location. Choose another one or try again.",
      "error_rate_limited": "We received several requests very quickly. Wait a moment and try again.",
      "error_submit": "We could not send your request. Your details are still here so you can try again."
    },
    "detail": {
      "title": "Service tracking",
      "request_title": "Your request",
      "location_label": "Location",
      "destination_label": "Destination",
      "when_label": "When",
      "details_label": "Details",
      "now": "You need it now",
      "scheduled": "{{date}} · {{window}}",
      "progress_title": "Tracking",
      "quote_title": "Tago proposal",
      "quote_confirm_note": "Once confirmed, Tago coordinates the details with you. Payment is agreed before the service is carried out.",
      "accept_quote_cta": "Confirm proposal",
      "quote_accepted": "Proposal confirmed",
      "accept_quote_dialog_title": "Confirm this proposal?",
      "accept_quote_dialog_body": "You will confirm the scope and price of {{amount}}. Tago will coordinate the next details with you before the service is carried out.",
      "accept_quote_confirm": "Yes, confirm",
      "cancel_cta": "Cancel request",
      "cancel_dialog_title": "Cancel this request?",
      "cancel_dialog_body": "Coordination stops and this request will not create a charge.",
      "cancel_confirm": "Yes, cancel",
      "cancel_error": "We could not cancel this request. Check its status and try again.",
      "accept_error": "We could not confirm this proposal. Check its status and try again.",
      "not_found_title": "We could not find this request",
      "not_found_body": "It may have closed or the link is no longer valid.",
      "back_to_services": "Back to Services"
    }
  },
  "retention": {
    "pair_fee_first_kicker": "First booking with this host",
    "pair_fee_repeat_kicker": "You're back with the same host",
    "pair_fee_first_title": "The first booking includes Tago protection and service",
    "pair_fee_repeat_title": "Your Tago fee is now {{pct}}%",
    "pair_fee_body": "This is not a discount on the car. It is Tago's commission, lower because the match already exists.",
    "pair_fee_next": "If you repeat, the next booking drops to {{pct}}%.",
    "pair_fee_floor": "This is the floor: 5% from here on with this host.",
    "tier_first": "1st",
    "tier_second": "2nd",
    "tier_rest": "3rd+",
    "coverage_kicker": "What WhatsApp cannot copy",
    "coverage_title": "Coverage, deposit, reputation, and payments",
    "coverage_body": "Off Tago the host owns collision, theft, and dispute. Inside there is a policy, escrow, reviews, and settlement.",
    "coverage_point_insurance": "Coverage and claims handling inside Tago",
    "coverage_point_escrow": "Held deposit against minor damage",
    "coverage_point_reputation": "Reviews that only live on the platform",
    "coverage_point_payments": "Traceable payment, not an informal deal"
  }
}
